var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportaion01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45.57 39.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{isolation:isolate;}.cls-4{fill:#fad264;}.cls-5{opacity:0.2;}.cls-170,.cls-28,.cls-56,.cls-6{fill:#afb6e5;}.cls-59,.cls-6{opacity:0;}.cls-7{fill:#abb2e2;opacity:0.05;}.cls-8{fill:#a7addf;opacity:0.1;}.cls-9{fill:#a3a9dc;opacity:0.14;}.cls-10{fill:#9fa4d8;opacity:0.19;}.cls-11{fill:#9ba0d5;opacity:0.24;}.cls-12{fill:#979bd2;opacity:0.29;}.cls-13{fill:#9397cf;opacity:0.33;}.cls-14{fill:#8f92cc;opacity:0.38;}.cls-15{fill:#8b8ec9;opacity:0.43;}.cls-16{fill:#8789c6;opacity:0.48;}.cls-17{fill:#8385c2;opacity:0.52;}.cls-18{fill:#7f80bf;opacity:0.57;}.cls-19{fill:#7b7cbc;opacity:0.62;}.cls-20{fill:#7777b9;opacity:0.67;}.cls-21{fill:#7373b6;opacity:0.71;}.cls-22{fill:#6f6eb3;opacity:0.76;}.cls-23{fill:#6b6ab0;opacity:0.81;}.cls-24{fill:#6765ac;opacity:0.86;}.cls-25{fill:#6361a9;opacity:0.9;}.cls-26{fill:#5f5ca6;opacity:0.95;}.cls-27{fill:#5b58a3;}.cls-29{fill:url(#linear-gradient-2);}.cls-30{fill:url(#linear-gradient-3);}.cls-31{fill:url(#linear-gradient-4);}.cls-32{fill:url(#linear-gradient-5);}.cls-33{fill:url(#linear-gradient-6);}.cls-34{fill:url(#linear-gradient-7);}.cls-35{fill:url(#linear-gradient-8);}.cls-36{fill:url(#linear-gradient-9);}.cls-37{fill:url(#linear-gradient-10);}.cls-38{fill:url(#linear-gradient-11);}.cls-39{fill:url(#linear-gradient-12);}.cls-40{fill:url(#linear-gradient-13);}.cls-41{fill:url(#linear-gradient-14);}.cls-42{fill:url(#linear-gradient-15);}.cls-43{fill:url(#linear-gradient-16);}.cls-44{fill:url(#linear-gradient-17);}.cls-45{fill:url(#linear-gradient-18);}.cls-46{fill:url(#linear-gradient-19);}.cls-47{fill:url(#linear-gradient-20);}.cls-48{fill:url(#linear-gradient-21);}.cls-49{fill:url(#linear-gradient-22);}.cls-50,.cls-59{fill:#fff;}.cls-51{fill:url(#linear-gradient-23);}.cls-52{fill:url(#linear-gradient-24);}.cls-53{fill:url(#linear-gradient-25);}.cls-54,.cls-56{opacity:0.8;}.cls-55{fill:url(#linear-gradient-26);}.cls-57{fill:#ffe585;}.cls-135,.cls-137,.cls-153,.cls-165,.cls-166,.cls-170,.cls-196,.cls-294,.cls-58{mix-blend-mode:multiply;}.cls-107,.cls-134,.cls-191,.cls-196,.cls-200,.cls-299,.cls-58,.cls-75{opacity:0.5;}.cls-60{fill:#fefeff;opacity:0.03;}.cls-61{fill:#fdfdff;opacity:0.06;}.cls-62{fill:#fdfbff;opacity:0.09;}.cls-63{fill:#fcfaff;opacity:0.13;}.cls-64{fill:#fbf9ff;opacity:0.16;}.cls-65{fill:#faf8ff;opacity:0.19;}.cls-66{fill:#faf6ff;opacity:0.22;}.cls-67{fill:#f9f5ff;opacity:0.25;}.cls-68{fill:#f8f4ff;opacity:0.28;}.cls-69{fill:#f7f3ff;opacity:0.31;}.cls-70{fill:#f6f1ff;opacity:0.34;}.cls-71{fill:#f6f0ff;opacity:0.38;}.cls-72{fill:#f5efff;opacity:0.41;}.cls-73{fill:#f4eeff;opacity:0.44;}.cls-74{fill:#f3ecff;opacity:0.47;}.cls-75{fill:#f3ebff;}.cls-76{fill:#f2eaff;opacity:0.53;}.cls-77{fill:#f1e9ff;opacity:0.56;}.cls-78{fill:#f0e7ff;opacity:0.59;}.cls-79{fill:#efe6ff;opacity:0.63;}.cls-80{fill:#efe5ff;opacity:0.66;}.cls-81{fill:#eee4ff;opacity:0.69;}.cls-82{fill:#ede2ff;opacity:0.72;}.cls-83{fill:#ece1ff;opacity:0.75;}.cls-84{fill:#ebe0ff;opacity:0.78;}.cls-85{fill:#ebdfff;opacity:0.81;}.cls-86{fill:#eaddff;opacity:0.84;}.cls-87{fill:#e9dcff;opacity:0.88;}.cls-88{fill:#e8dbff;opacity:0.91;}.cls-89{fill:#e8daff;opacity:0.94;}.cls-90{fill:#e7d8ff;opacity:0.97;}.cls-91{fill:#e6d7ff;}.cls-92{fill:url(#linear-gradient-27);}.cls-93{fill:url(#linear-gradient-28);}.cls-94{fill:url(#linear-gradient-29);}.cls-116,.cls-131,.cls-134,.cls-139,.cls-172,.cls-179,.cls-186,.cls-95,.cls-96{mix-blend-mode:color-dodge;}.cls-95{fill:url(#Radial_Gradient_1);}.cls-96{fill:url(#Radial_Gradient_1-2);}.cls-97{fill:#a7aedd;opacity:0.05;}.cls-98{fill:#9ea5d5;opacity:0.09;}.cls-99{fill:#969dce;opacity:0.14;}.cls-100{fill:#8d94c6;opacity:0.18;}.cls-101{fill:#858cbe;opacity:0.23;}.cls-102{fill:#7c83b6;opacity:0.27;}.cls-103{fill:#747bae;opacity:0.32;}.cls-104{fill:#6b72a6;opacity:0.36;}.cls-105{fill:#636a9f;opacity:0.41;}.cls-106{fill:#5a6197;opacity:0.45;}.cls-107{fill:#52598f;}.cls-108{fill:url(#linear-gradient-30);}.cls-109{fill:url(#linear-gradient-31);}.cls-110{fill:url(#linear-gradient-32);}.cls-111{fill:url(#linear-gradient-33);}.cls-112{fill:#a4abde;}.cls-113{fill:url(#linear-gradient-34);}.cls-114{fill:url(#linear-gradient-35);}.cls-115{fill:url(#linear-gradient-36);}.cls-116{fill:url(#Radial_Gradient_1-3);}.cls-117{fill:url(#linear-gradient-37);}.cls-118{fill:url(#linear-gradient-38);}.cls-119{fill:url(#linear-gradient-39);}.cls-120{fill:url(#linear-gradient-40);}.cls-121{fill:url(#linear-gradient-41);}.cls-122{fill:url(#linear-gradient-42);}.cls-123{fill:url(#New_Gradient_Swatch_copy_22);}.cls-124,.cls-151{mix-blend-mode:screen;}.cls-124{fill:url(#Radial_Gradient_1-4);}.cls-125{fill:url(#linear-gradient-43);}.cls-126{fill:url(#linear-gradient-44);}.cls-127{fill:url(#linear-gradient-45);}.cls-128{fill:url(#linear-gradient-46);}.cls-129{fill:url(#linear-gradient-47);}.cls-130{fill:url(#linear-gradient-48);}.cls-132{fill:url(#Radial_Gradient_1-5);}.cls-133{fill:url(#Radial_Gradient_1-6);}.cls-134{fill:url(#radial-gradient);}.cls-135{fill:url(#linear-gradient-49);}.cls-136{fill:url(#linear-gradient-50);}.cls-137{fill:url(#linear-gradient-51);}.cls-138{fill:url(#linear-gradient-52);}.cls-139{fill:url(#radial-gradient-2);}.cls-140{fill:url(#linear-gradient-53);}.cls-141{fill:url(#linear-gradient-54);}.cls-142{fill:url(#linear-gradient-55);}.cls-143{fill:url(#linear-gradient-56);}.cls-144{fill:url(#linear-gradient-57);}.cls-145{fill:url(#linear-gradient-58);}.cls-146{fill:url(#linear-gradient-59);}.cls-147{fill:url(#linear-gradient-60);}.cls-148{fill:url(#linear-gradient-61);}.cls-149{fill:url(#linear-gradient-62);}.cls-150{fill:url(#linear-gradient-63);}.cls-151{fill:url(#Radial_Gradient_1-7);}.cls-152{fill:url(#linear-gradient-64);}.cls-153{fill:url(#linear-gradient-65);}.cls-154{fill:url(#linear-gradient-66);}.cls-155{fill:url(#linear-gradient-67);}.cls-156{fill:url(#linear-gradient-68);}.cls-157{fill:url(#linear-gradient-69);}.cls-158{fill:url(#linear-gradient-70);}.cls-159{fill:url(#linear-gradient-71);}.cls-160{fill:url(#linear-gradient-72);}.cls-161{fill:url(#linear-gradient-73);}.cls-162{fill:url(#linear-gradient-74);}.cls-163{fill:url(#New_Gradient_Swatch_copy_25);}.cls-164{fill:url(#linear-gradient-75);}.cls-165,.cls-287{fill:#e5e9ff;}.cls-166{fill:#ced3f4;}.cls-167{fill:url(#linear-gradient-76);}.cls-168{fill:#4e0070;}.cls-169{fill:url(#linear-gradient-77);}.cls-171{fill:url(#linear-gradient-78);}.cls-172{fill:url(#Radial_Gradient_1-8);}.cls-173{fill:url(#linear-gradient-79);}.cls-174{fill:url(#linear-gradient-80);}.cls-175{fill:url(#linear-gradient-81);}.cls-176{fill:url(#linear-gradient-82);}.cls-177{fill:url(#linear-gradient-83);}.cls-178{fill:url(#linear-gradient-84);}.cls-179{fill:url(#radial-gradient-3);}.cls-180{fill:url(#linear-gradient-85);}.cls-181{fill:url(#linear-gradient-86);}.cls-182{fill:url(#linear-gradient-87);}.cls-183{fill:url(#linear-gradient-88);}.cls-184{fill:url(#linear-gradient-89);}.cls-185{fill:url(#linear-gradient-90);}.cls-186{fill:url(#radial-gradient-4);}.cls-187{clip-path:url(#clip-path);}.cls-188{fill:url(#linear-gradient-91);}.cls-189{fill:url(#linear-gradient-92);}.cls-190{fill:url(#linear-gradient-93);}.cls-191{fill:url(#linear-gradient-94);}.cls-192{fill:url(#linear-gradient-95);}.cls-193{fill:url(#linear-gradient-96);}.cls-194{fill:url(#linear-gradient-97);}.cls-195{fill:url(#linear-gradient-98);}.cls-196,.cls-294{fill:#f1d5be;}.cls-197{fill:url(#linear-gradient-99);}.cls-198{fill:url(#linear-gradient-100);}.cls-199{fill:url(#linear-gradient-101);}.cls-200{fill:url(#linear-gradient-102);}.cls-201{fill:url(#linear-gradient-103);}.cls-202{fill:url(#linear-gradient-104);}.cls-203{fill:url(#linear-gradient-105);}.cls-204{fill:url(#linear-gradient-106);}.cls-205{fill:url(#linear-gradient-107);}.cls-206{fill:url(#linear-gradient-108);}.cls-207{clip-path:url(#clip-path-2);}.cls-208{fill:url(#linear-gradient-110);}.cls-209{fill:url(#linear-gradient-111);}.cls-210{fill:url(#linear-gradient-112);}.cls-211{fill:url(#linear-gradient-113);}.cls-212{fill:url(#linear-gradient-114);}.cls-213{fill:url(#linear-gradient-115);}.cls-214{fill:url(#linear-gradient-116);}.cls-215{fill:url(#linear-gradient-117);}.cls-216{fill:url(#linear-gradient-118);}.cls-217{fill:url(#linear-gradient-119);}.cls-218{fill:url(#linear-gradient-120);}.cls-219{fill:url(#linear-gradient-121);}.cls-220{fill:url(#linear-gradient-122);}.cls-221{fill:url(#linear-gradient-123);}.cls-222{fill:url(#linear-gradient-124);}.cls-223{fill:url(#linear-gradient-125);}.cls-224{fill:url(#linear-gradient-126);}.cls-225{fill:url(#linear-gradient-127);}.cls-226{fill:url(#linear-gradient-128);}.cls-227{fill:url(#linear-gradient-129);}.cls-228{fill:url(#linear-gradient-130);}.cls-229{fill:url(#linear-gradient-131);}.cls-230{fill:url(#linear-gradient-132);}.cls-231{fill:url(#linear-gradient-133);}.cls-232{fill:url(#linear-gradient-134);}.cls-233{fill:url(#linear-gradient-135);}.cls-234{fill:url(#linear-gradient-136);}.cls-235{fill:url(#linear-gradient-137);}.cls-236{fill:url(#linear-gradient-138);}.cls-237{fill:url(#linear-gradient-139);}.cls-238{fill:url(#linear-gradient-140);}.cls-239{fill:url(#linear-gradient-141);}.cls-240{fill:url(#linear-gradient-142);}.cls-241{fill:url(#linear-gradient-143);}.cls-242{fill:url(#linear-gradient-144);}.cls-243{fill:url(#linear-gradient-145);}.cls-244{fill:url(#linear-gradient-146);}.cls-245{fill:url(#linear-gradient-147);}.cls-246{fill:url(#linear-gradient-148);}.cls-247{fill:url(#linear-gradient-149);}.cls-248{fill:url(#linear-gradient-150);}.cls-249{fill:url(#linear-gradient-151);}.cls-250{fill:url(#linear-gradient-152);}.cls-251{fill:url(#linear-gradient-153);}.cls-252{fill:url(#linear-gradient-154);}.cls-253{fill:url(#linear-gradient-155);}.cls-254{fill:url(#linear-gradient-156);}.cls-255{fill:url(#linear-gradient-157);}.cls-256{fill:url(#linear-gradient-158);}.cls-257{fill:url(#linear-gradient-159);}.cls-258{fill:url(#linear-gradient-160);}.cls-259{fill:url(#linear-gradient-161);}.cls-260{fill:url(#linear-gradient-162);}.cls-261{fill:url(#linear-gradient-163);}.cls-262{fill:url(#linear-gradient-164);}.cls-263{fill:url(#linear-gradient-165);}.cls-264{fill:url(#linear-gradient-166);}.cls-265{fill:url(#linear-gradient-167);}.cls-266{fill:url(#linear-gradient-168);}.cls-267{fill:url(#linear-gradient-169);}.cls-268{fill:url(#linear-gradient-170);}.cls-269{fill:url(#linear-gradient-171);}.cls-270{fill:url(#linear-gradient-172);}.cls-271{fill:url(#linear-gradient-173);}.cls-272{fill:url(#linear-gradient-174);}.cls-273{fill:url(#linear-gradient-175);}.cls-274{fill:url(#linear-gradient-176);}.cls-275{fill:url(#linear-gradient-177);}.cls-276{fill:url(#linear-gradient-178);}.cls-277{fill:url(#linear-gradient-179);}.cls-278{fill:url(#linear-gradient-180);}.cls-279{fill:url(#linear-gradient-181);}.cls-280{fill:url(#linear-gradient-182);}.cls-281{fill:url(#linear-gradient-183);}.cls-282{fill:url(#linear-gradient-184);}.cls-283{fill:url(#linear-gradient-185);}.cls-284{fill:url(#linear-gradient-186);}.cls-285{fill:#ffd4c0;}.cls-286{fill:url(#linear-gradient-187);}.cls-288{fill:url(#linear-gradient-188);}.cls-289{fill:#2b003d;}.cls-290{fill:url(#linear-gradient-189);}.cls-291{fill:url(#linear-gradient-190);}.cls-292{fill:url(#linear-gradient-191);}.cls-293{fill:url(#linear-gradient-192);}.cls-295{fill:url(#linear-gradient-193);}.cls-296{fill:url(#linear-gradient-194);}.cls-297{fill:url(#linear-gradient-195);}.cls-298{fill:url(#linear-gradient-196);}.cls-299{fill:url(#linear-gradient-197);}.cls-300{fill:url(#linear-gradient-198);}.cls-301{fill:url(#linear-gradient-199);}.cls-302{fill:url(#linear-gradient-200);}.cls-303{fill:url(#linear-gradient-201);}.cls-304{fill:#35004d;}.cls-305{fill:url(#linear-gradient-202);}.cls-306{fill:url(#linear-gradient-203);}.cls-307{fill:url(#linear-gradient-204);}.cls-308{fill:url(#New_Gradient_Swatch_copy_36);}.cls-309{fill:url(#linear-gradient-205);}.cls-310{fill:url(#linear-gradient-206);}.cls-311{fill:#5277f7;}.cls-312{fill:url(#linear-gradient-207);}.cls-313{fill:url(#linear-gradient-208);}.cls-314{fill:url(#linear-gradient-209);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.38,
    y1: 27.41,
    x2: 14.54,
    y2: 19.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5277f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7670f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8c6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a46df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb6df3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 28.6,
    y1: 1.07,
    x2: 38.73,
    y2: 32.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0b7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b2b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b3b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 28.59,
    y1: 1.08,
    x2: 38.72,
    y2: 32.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2b9e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 28.58,
    y1: 1.08,
    x2: 38.71,
    y2: 32.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3bae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b7bde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bac0e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3bae7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 28.57,
    y1: 1.08,
    x2: 38.7,
    y2: 32.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b9c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bec4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bbe8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 28.56,
    y1: 1.09,
    x2: 38.69,
    y2: 32.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6bde8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c2c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6bde8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 28.55,
    y1: 1.09,
    x2: 38.68,
    y2: 32.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8bee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bec5ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c6cbec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b2b9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8bee9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 28.54,
    y1: 1.1,
    x2: 38.67,
    y2: 32.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bfea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c1c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#caceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#b6bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9bfea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 28.53,
    y1: 1.1,
    x2: 38.66,
    y2: 32.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c4c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#cdd2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b9c0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 28.52,
    y1: 1.11,
    x2: 38.65,
    y2: 32.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c6ccf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d0d4f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d1d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bdc3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcc2eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 28.51,
    y1: 1.11,
    x2: 38.64,
    y2: 32.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c9cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d3d7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d5d9f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c1c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc3ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 28.5,
    y1: 1.11,
    x2: 38.63,
    y2: 32.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc5ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cbd1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d5d9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d9dcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c5caec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfc5ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 28.49,
    y1: 1.12,
    x2: 38.62,
    y2: 32.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0c6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ced3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d8dcf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dde0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c9ceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c6ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 28.48,
    y1: 1.12,
    x2: 38.61,
    y2: 32.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d0d6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dadef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e1e3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#cdd1ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c7ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 28.47,
    y1: 1.13,
    x2: 38.6,
    y2: 32.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d3d8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dde1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e4e7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d0d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c9ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 28.46,
    y1: 1.13,
    x2: 38.59,
    y2: 32.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d6daf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e0e3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e8eaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d4d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4caef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 28.45,
    y1: 1.13,
    x2: 38.58,
    y2: 32.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6cbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d8ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e2e6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#eceef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d8dcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6cbf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 28.44,
    y1: 1.14,
    x2: 38.57,
    y2: 32.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7cdf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e5e8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f0f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#dcdff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7cdf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 28.43,
    y1: 1.14,
    x2: 38.56,
    y2: 32.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9cef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#dde2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e7eafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f4f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e0e3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9cef1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 28.42,
    y1: 1.15,
    x2: 38.55,
    y2: 32.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e0e4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eaedfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f7f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e3e6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b1b8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 28.41,
    y1: 1.15,
    x2: 38.54,
    y2: 32.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccd1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e2e7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eceffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fbfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e7eaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b5bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 28.4,
    y1: 1.15,
    x2: 38.53,
    y2: 32.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdd2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eff2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ebedf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b9bfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd2f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 12.33,
    y1: 25.36,
    x2: 48.06,
    y2: 10.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b6bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f5f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 26.24,
    y1: 4.94,
    x2: 42.03,
    y2: 35.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#273b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2f2ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361cac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440b89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 40.73,
    y1: 16.16,
    x2: 35.59,
    y2: 13.4,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 45.68,
    y1: -15.58,
    x2: 26.61,
    y2: 20.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#bb6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5277f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 27.39,
    y1: 2.71,
    x2: 29.63,
    y2: 6.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a942f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#b84bef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e161e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff72de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b257f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 31.6,
    y1: 10,
    x2: 27.25,
    y2: 0.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8857f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9c4af3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a942f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b84bef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e161e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f96fdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fd86e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff72de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b257f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 24.04,
    y1: 9.69,
    x2: 30.6,
    y2: 2.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#836df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#bb6df3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ca6dea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36dd4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 30.25,
    cy: 4.13,
    r: 4.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    cx: 28.47,
    cy: 4.93,
    r: 1.57,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 14.67,
    y1: 2.76,
    x2: 7.73,
    y2: 15.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b6bce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8cdf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ced3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dee2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -5.33,
    y1: 22.84,
    x2: 15.16,
    y2: 18.25,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 7.78,
    y1: 20.29,
    x2: 25.51,
    y2: 14.98,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 5094.02,
    y1: 20.21,
    x2: 5095.62,
    y2: 20.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 2.73,
    y1: 18.02,
    x2: 6.52,
    y2: 18.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#290b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#430d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33065c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 3.55,
    y1: 15.79,
    x2: 6.34,
    y2: 21.07,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 5097.66,
    y1: 17.44,
    x2: 5098.39,
    y2: 17.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    cx: 5098.04,
    cy: 17.2,
    r: 0.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1.55,
    y1: 20.71,
    x2: 2.97,
    y2: 24.51,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 4.06,
    y1: 21.25,
    x2: 1.4,
    y2: 22.38,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -4301.37,
    y1: 25.25,
    x2: -4304.25,
    y2: 21.39,
    gradientTransform: "translate(4307.72)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 5095.25,
    y1: 23.53,
    x2: 5100.84,
    y2: 24.6,
    gradientTransform: "matrix(-0.86, -0.5, -0.5, 0.86, 4416.21, 2575.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4513a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#430d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33065c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 5095.57,
    y1: 23.81,
    x2: 5097.91,
    y2: 23.81,
    gradientTransform: "matrix(-0.86, -0.5, -0.5, 0.86, 4416.19, 2575.54)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5095.57,
    y1: 23.76,
    x2: 5097.63,
    y2: 23.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_22",
    cx: 5096.6,
    cy: 23.82,
    r: 0.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eeebf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a5a6b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9eb3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-4",
    cx: -4303.22,
    cy: 23.76,
    r: 1.77,
    gradientTransform: "translate(4307.72)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 5095.64,
    y1: 23.79,
    x2: 5097.51,
    y2: 23.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -4303,
    y1: 24.26,
    x2: -4303.79,
    y2: 23.2,
    gradientTransform: "translate(4307.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#b9c0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d4d9f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dbdffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c3c9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b4bbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#afb6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#bac0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced3f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 5096.29,
    y1: 23.67,
    x2: 5098.19,
    y2: 24.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 5095.68,
    y1: 25.58,
    x2: 5095.52,
    y2: 20.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 5096.26,
    y1: 23.7,
    x2: 5093.77,
    y2: 21.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 5095.31,
    y1: 23.09,
    x2: 5105.11,
    y2: 23.18,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-5",
    cx: 5096.06,
    cy: 22.94,
    r: 1.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-6",
    cx: 5097.99,
    cy: 22.23,
    r: 0.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 3360.66,
    cy: 4626.03,
    r: 2.55,
    gradientTransform: "matrix(0, -0.82, -0.44, 0, 2028.65, 2777.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b887ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f74dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7a59a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#59427c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3e2d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#271d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#16101e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0a070d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 2.12,
    y1: 20.78,
    x2: 1.73,
    y2: 20.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f695e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f9c2ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fce3f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fdf7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 2.15,
    y1: 20.98,
    x2: 1.81,
    y2: 21.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ffbc9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1.84,
    y1: 20.84,
    x2: 1.94,
    y2: 21.41,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -481.37,
    y1: -165.12,
    x2: -481.13,
    y2: -165.12,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, -464.43, 224.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ff9e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffad73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffd680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -1457.06,
    cy: -2301.95,
    r: 0.85,
    gradientTransform: "matrix(-0.32, 0.76, 0.49, 0.21, 663.69, 1596.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dcc590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a9976f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7c6f51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#564d38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#363124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e1b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0d0c09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 5088.3,
    y1: 27.01,
    x2: 5099.98,
    y2: 23.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#33065c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#430d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4513a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 5084.16,
    y1: 28.15,
    x2: 5089.27,
    y2: 27,
    xlinkHref: "#linear-gradient-53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 5094.23,
    y1: 15.87,
    x2: 5088.58,
    y2: 26.63,
    xlinkHref: "#linear-gradient-53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 10.6,
    y1: 26.85,
    x2: 10.24,
    y2: 27.51,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 7.96,
    y1: 25.32,
    x2: 9.22,
    y2: 25.15,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 4.29,
    y1: 29.06,
    x2: 19.16,
    y2: 23.27,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 12.93,
    y1: 28.16,
    x2: 14.19,
    y2: 27.98,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 11.1,
    y1: 24.21,
    x2: 10.21,
    y2: 25.79,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 16.32,
    y1: 27.59,
    x2: 13.96,
    y2: 28.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -3880.29,
    y1: 31.91,
    x2: -3883.15,
    y2: 28.07,
    gradientTransform: "translate(3898.32)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 5083.85,
    y1: 29.92,
    x2: 5088.27,
    y2: 31.99,
    gradientTransform: "matrix(-0.86, -0.5, -0.5, 0.86, 4421.17, 2570.53)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-7",
    cx: -3882.15,
    cy: 30.44,
    r: 1.76,
    gradientTransform: "translate(3898.32)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -3881.65,
    y1: 30.11,
    x2: -3885.42,
    y2: 32.17,
    gradientTransform: "translate(3898.32)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 5083.13,
    y1: 29.74,
    x2: 5085.91,
    y2: 31.19,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 5085.28,
    y1: 29.87,
    x2: 5084.62,
    y2: 31.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 5083.52,
    y1: 29.82,
    x2: 5085.87,
    y2: 31.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 15.33,
    y1: 31.94,
    x2: 16.57,
    y2: 26.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 21.03,
    y1: 29.93,
    x2: 18.14,
    y2: 30.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 5081.27,
    y1: 31,
    x2: 5082.74,
    y2: 30.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 20.11,
    y1: 29.67,
    x2: 34.22,
    y2: 25.44,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 5079.28,
    y1: 27.07,
    x2: 5078.74,
    y2: 28.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 5081.65,
    y1: 30.46,
    x2: 5083.22,
    y2: 29.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 21.53,
    y1: 26.09,
    x2: 22.31,
    y2: 28.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25",
    x1: 5079.32,
    y1: 26.31,
    x2: 5078.73,
    y2: 27.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -4.61,
    y1: 27.03,
    x2: 31.89,
    y2: 18.85,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 19.58,
    y1: 25.2,
    x2: 37.79,
    y2: 19.75,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 5095.12,
    y1: -3.64,
    x2: 5082.76,
    y2: 19.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 5100.9, 0)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 20.99,
    y1: 29.45,
    x2: 26.5,
    y2: 27.49,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-8",
    cx: 4828.52,
    cy: 28.71,
    r: 0.78,
    gradientTransform: "matrix(-1, 0, 0, 1, 4850.16, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 24.46,
    y1: 27.36,
    x2: 25.52,
    y2: 27.36,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 24.99,
    y1: 27.21,
    x2: 25.52,
    y2: 27.21,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1416.86,
    y1: 27.56,
    x2: 1417.16,
    y2: 27.56,
    gradientTransform: "translate(-1392.35)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -453.25,
    y1: 27.56,
    x2: -453.02,
    y2: 27.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -428.39, 0)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1417.44,
    y1: 27.21,
    x2: 1417.75,
    y2: 27.21,
    gradientTransform: "translate(-1392.35)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -453.84,
    y1: 27.22,
    x2: -453.61,
    y2: 27.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -428.39, 0)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 2140.65,
    cy: -4267.94,
    r: 1,
    gradientTransform: "matrix(-0.75, 0.33, 0.17, 0.4, 2380.33, 1037.63)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 18.84,
    y1: 30.57,
    x2: 19.9,
    y2: 30.57,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 19.37,
    y1: 30.42,
    x2: 19.9,
    y2: 30.42,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1411.23,
    y1: 30.77,
    x2: 1411.54,
    y2: 30.77,
    gradientTransform: "translate(-1392.35)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -447.63,
    y1: 30.77,
    x2: -447.4,
    y2: 30.77,
    gradientTransform: "matrix(-1, 0, 0, 1, -428.39, 0)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1411.82,
    y1: 30.42,
    x2: 1412.13,
    y2: 30.42,
    gradientTransform: "translate(-1392.35)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -448.22,
    y1: 30.43,
    x2: -447.98,
    y2: 30.43,
    gradientTransform: "matrix(-1, 0, 0, 1, -428.39, 0)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 2148.8,
    cy: -4266.29,
    r: 1,
    gradientTransform: "matrix(-0.75, 0.33, 0.17, 0.4, 2380.33, 1037.63)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.05 26.28 25.05 19.35 19.49 22.53 19.49 29.45 25.05 26.28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -4185.12,
    y1: 25.97,
    x2: -4178.74,
    y2: 24.06,
    gradientTransform: "translate(4202.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e67a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ec894d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fcb262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -4187.18,
    y1: 25.62,
    x2: -4179.14,
    y2: 23.82,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -4179.49,
    y1: 17.92,
    x2: -4182.23,
    y2: 23.13,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -4179.64,
    y1: 18.2,
    x2: -4182.24,
    y2: 23.17,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -4180.9,
    y1: 23.76,
    x2: -4179.4,
    y2: 23.31,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -4181.27,
    y1: 21.43,
    x2: -4181.99,
    y2: 22.81,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -5467.92,
    y1: -3777.81,
    x2: -5466.97,
    y2: -3777.3,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 4755.98, 1653.97)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -5467.38,
    y1: -3777.81,
    x2: -5466.43,
    y2: -3777.3,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 4755.98, 1653.97)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -4181.63,
    y1: 26.6,
    x2: -4177.57,
    y2: 25.38,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -4182.94,
    y1: 26.37,
    x2: -4177.82,
    y2: 25.23,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -4178.05,
    y1: 21.47,
    x2: -4179.79,
    y2: 24.79,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -4178.14,
    y1: 21.65,
    x2: -4179.8,
    y2: 24.81,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -4178.94,
    y1: 25.19,
    x2: -4177.99,
    y2: 24.91,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -4179.18,
    y1: 23.71,
    x2: -4179.64,
    y2: 24.59,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -5465.33,
    y1: -3776.06,
    x2: -5464.73,
    y2: -3775.74,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 4755.98, 1653.97)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -5464.99,
    y1: -3776.06,
    x2: -5464.38,
    y2: -3775.74,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 4755.98, 1653.97)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 18.32,
    y1: 28.09,
    x2: 13.48,
    y2: 20.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 18.49,
    y1: 27.98,
    x2: 13.65,
    y2: 20.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.9,24.08s-.07.27-.27.33a.44.44,0,0,1-.43-.12s.18.06.32-.21a2,2,0,0,0,0-1.27s-.19.75-.76.42c-.36-.21-.81-.34-1-.22a1,1,0,0,1,.21.1,2.55,2.55,0,0,1,1.17,2,1.14,1.14,0,0,1-.06.39,1.26,1.26,0,0,0,.65-.36C18,24.85,17.9,24.08,17.9,24.08Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 20.15,
    y1: 26.91,
    x2: 15.31,
    y2: 19.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 20.06,
    y1: 26.97,
    x2: 15.22,
    y2: 19.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 20.01,
    y1: 27,
    x2: 15.17,
    y2: 19.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 19.97,
    y1: 27.03,
    x2: 15.12,
    y2: 19.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 19.92,
    y1: 27.06,
    x2: 15.08,
    y2: 19.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 19.87,
    y1: 27.09,
    x2: 15.03,
    y2: 19.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 19.82,
    y1: 27.12,
    x2: 14.98,
    y2: 19.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 19.78,
    y1: 27.16,
    x2: 14.93,
    y2: 19.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 19.75,
    y1: 27.17,
    x2: 14.91,
    y2: 19.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 19.73,
    y1: 27.19,
    x2: 14.89,
    y2: 19.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 19.71,
    y1: 27.2,
    x2: 14.86,
    y2: 19.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 19.69,
    y1: 27.21,
    x2: 14.84,
    y2: 19.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 19.66,
    y1: 27.23,
    x2: 14.82,
    y2: 19.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 19.64,
    y1: 27.24,
    x2: 14.8,
    y2: 19.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 19.62,
    y1: 27.25,
    x2: 14.78,
    y2: 19.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 19.6,
    y1: 27.27,
    x2: 14.76,
    y2: 19.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 19.58,
    y1: 27.28,
    x2: 14.74,
    y2: 19.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 19.56,
    y1: 27.3,
    x2: 14.72,
    y2: 19.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 19.54,
    y1: 27.31,
    x2: 14.69,
    y2: 19.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 19.52,
    y1: 27.32,
    x2: 14.67,
    y2: 19.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 19.5,
    y1: 27.33,
    x2: 14.65,
    y2: 19.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 19.48,
    y1: 27.35,
    x2: 14.63,
    y2: 19.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 19.46,
    y1: 27.36,
    x2: 14.61,
    y2: 19.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 19.44,
    y1: 27.37,
    x2: 14.59,
    y2: 19.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 19.42,
    y1: 27.39,
    x2: 14.57,
    y2: 19.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 19.4,
    y1: 27.4,
    x2: 14.56,
    y2: 19.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 19.38,
    y1: 27.41,
    x2: 14.54,
    y2: 19.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 19.36,
    y1: 27.42,
    x2: 14.52,
    y2: 19.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 19.34,
    y1: 27.44,
    x2: 14.5,
    y2: 19.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 19.32,
    y1: 27.45,
    x2: 14.48,
    y2: 19.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 19.3,
    y1: 27.46,
    x2: 14.46,
    y2: 19.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 19.28,
    y1: 27.48,
    x2: 14.44,
    y2: 19.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 19.26,
    y1: 27.49,
    x2: 14.42,
    y2: 19.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 19.24,
    y1: 27.5,
    x2: 14.4,
    y2: 19.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 19.22,
    y1: 27.51,
    x2: 14.38,
    y2: 19.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 19.2,
    y1: 27.53,
    x2: 14.36,
    y2: 20.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 19.18,
    y1: 27.54,
    x2: 14.34,
    y2: 20.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 19.16,
    y1: 27.55,
    x2: 14.32,
    y2: 20.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 19.14,
    y1: 27.57,
    x2: 14.3,
    y2: 20.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 19.12,
    y1: 27.58,
    x2: 14.28,
    y2: 20.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 19.1,
    y1: 27.59,
    x2: 14.26,
    y2: 20.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 19.08,
    y1: 27.6,
    x2: 14.24,
    y2: 20.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 19.06,
    y1: 27.62,
    x2: 14.22,
    y2: 20.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 19.04,
    y1: 27.63,
    x2: 14.2,
    y2: 20.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 19.02,
    y1: 27.64,
    x2: 14.18,
    y2: 20.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 19,
    y1: 27.66,
    x2: 14.16,
    y2: 20.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 18.98,
    y1: 27.67,
    x2: 14.14,
    y2: 20.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 18.96,
    y1: 27.68,
    x2: 14.12,
    y2: 20.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 18.94,
    y1: 27.69,
    x2: 14.1,
    y2: 20.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 18.92,
    y1: 27.71,
    x2: 14.08,
    y2: 20.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 18.9,
    y1: 27.72,
    x2: 14.06,
    y2: 20.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 18.88,
    y1: 27.73,
    x2: 14.04,
    y2: 20.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 18.86,
    y1: 27.75,
    x2: 14.02,
    y2: 20.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 18.84,
    y1: 27.76,
    x2: 14,
    y2: 20.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 18.82,
    y1: 27.77,
    x2: 13.98,
    y2: 20.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 18.8,
    y1: 27.79,
    x2: 13.96,
    y2: 20.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 18.78,
    y1: 27.8,
    x2: 13.93,
    y2: 20.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 18.76,
    y1: 27.81,
    x2: 13.91,
    y2: 20.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 18.73,
    y1: 27.83,
    x2: 13.89,
    y2: 20.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 18.71,
    y1: 27.84,
    x2: 13.87,
    y2: 20.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 18.69,
    y1: 27.85,
    x2: 13.85,
    y2: 20.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 18.67,
    y1: 27.87,
    x2: 13.83,
    y2: 20.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 18.65,
    y1: 27.88,
    x2: 13.81,
    y2: 20.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 18.63,
    y1: 27.89,
    x2: 13.79,
    y2: 20.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 18.59,
    y1: 27.92,
    x2: 13.74,
    y2: 20.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 18.54,
    y1: 27.95,
    x2: 13.7,
    y2: 20.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 18.49,
    y1: 27.98,
    x2: 13.65,
    y2: 20.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 18.44,
    y1: 28.01,
    x2: 13.6,
    y2: 20.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 18.33,
    y1: 28.09,
    x2: 13.48,
    y2: 20.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 16.89,
    y1: 27.65,
    x2: 6.73,
    y2: 17.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 17.06,
    y1: 27.46,
    x2: 6.9,
    y2: 17.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 17.16,
    y1: 27.36,
    x2: 7,
    y2: 17.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 17.29,
    y1: 27.22,
    x2: 7.14,
    y2: 17.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 17.43,
    y1: 27.08,
    x2: 7.27,
    y2: 17.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 17.55,
    y1: 26.95,
    x2: 7.39,
    y2: 17.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 17.67,
    y1: 26.82,
    x2: 7.52,
    y2: 17.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 17.87,
    y1: 26.62,
    x2: 7.71,
    y2: 16.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 297.88,
    y1: -617.94,
    x2: 297.88,
    y2: -623.49,
    gradientTransform: "translate(-178.32 679.47) rotate(-7.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#09cebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#21e1ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2be9a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 9490.44,
    y1: 24.47,
    x2: 9491.56,
    y2: 23.78,
    gradientTransform: "matrix(-1, 0, 0, 1, 9525.71, 0)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 9490.89,
    y1: 32.9,
    x2: 9490.77,
    y2: 26.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 9525.71, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 9489.15,
    y1: 33.71,
    x2: 9489.48,
    y2: 26.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 9525.71, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 9491.56,
    y1: 27.05,
    x2: 9491.08,
    y2: 21.4,
    gradientTransform: "matrix(-1, 0, 0, 1, 9525.71, 0)",
    xlinkHref: "#linear-gradient-187"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 9489.61,
    y1: 27.71,
    x2: 9489.51,
    y2: 21.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 9525.71, 0)",
    xlinkHref: "#linear-gradient-187"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 9489.91,
    y1: 21.36,
    x2: 9491.73,
    y2: 20.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 9525.71, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff9e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -4174.07,
    y1: 29.3,
    x2: -4168.03,
    y2: 27.49,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -4176.02,
    y1: 28.97,
    x2: -4168.41,
    y2: 27.26,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: -4168.74,
    y1: 21.68,
    x2: -4171.33,
    y2: 26.61,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: -4168.88,
    y1: 21.94,
    x2: -4171.34,
    y2: 26.64,
    gradientTransform: "translate(4202.44)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -4170.07,
    y1: 27.21,
    x2: -4168.65,
    y2: 26.78,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: -4170.42,
    y1: 25,
    x2: -4171.11,
    y2: 26.31,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: -5455.36,
    y1: -3769.48,
    x2: -5454.47,
    y2: -3769,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 4755.98, 1653.97)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: -5454.85,
    y1: -3769.48,
    x2: -5453.95,
    y2: -3769,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 4755.98, 1653.97)",
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -9151.72,
    y1: 37.34,
    x2: -9151.02,
    y2: 30.65,
    gradientTransform: "translate(9179.09)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -9149.89,
    y1: 38.01,
    x2: -9149.94,
    y2: 30.4,
    gradientTransform: "translate(9179.09)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -9154.85,
    y1: 370.36,
    x2: -9153.84,
    y2: 364.68,
    gradientTransform: "translate(9190.07 -4.16) rotate(2.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36",
    x1: -9030.45,
    y1: -1214.12,
    x2: -9030.88,
    y2: -1215.66,
    gradientTransform: "matrix(0.99, -0.13, 0.13, 0.99, 9141.56, 18.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 30.45,
    y1: 31.94,
    x2: 31.23,
    y2: 26.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 210.41,
    y1: -426.89,
    x2: 210.99,
    y2: -432.83,
    gradientTransform: "translate(-132.83 472.39) rotate(-5.34)",
    xlinkHref: "#linear-gradient-187"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 29.13,
    y1: 24.37,
    x2: 30.25,
    y2: 24.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 28.06,
    y1: 24.41,
    x2: 29.94,
    y2: 24.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 28.26,
    y1: 24.75,
    x2: 30.26,
    y2: 23.63,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.18 34.23 20.32 30.06 20.32 29.41 27.19 33.58 32.8 30.45 33.08 30.94 27.18 34.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.55,33.93a1.92,1.92,0,0,1-1-.24l-5-2.94-5-2.95a1,1,0,0,1-.57-.9,1.21,1.21,0,0,1,.68-1l4.11-2.8a2.47,2.47,0,0,1,1.19-.3A1.94,1.94,0,0,1,34,23l5.51,3.09L45,29.22a1,1,0,0,1,.56.89,1.19,1.19,0,0,1-.68,1l-5.15,2.5A2.44,2.44,0,0,1,38.55,33.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27.71,25.92l1.07-.72s2-1.37,2.07-1.36l.92-.59A2.45,2.45,0,0,1,32.93,23a2,2,0,0,1,1,.24l4.28,2.41,1.14.64,5.42,3a1.34,1.34,0,0,1,.41.37.89.89,0,0,1,.15.5,1.17,1.17,0,0,1-.66,1l-1.16.56s-2.24,1.07-2.26,1.06l-1.64.74a2.4,2.4,0,0,1-1.17.27,1.92,1.92,0,0,1-1-.24l-3.42-2-1.49-.88-4.92-2.9a1.26,1.26,0,0,1-.41-.38,1,1,0,0,1-.15-.49A1.19,1.19,0,0,1,27.71,25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.73,26l1-.7c.05,0,2-1.32,2.05-1.29l.9-.54a2.38,2.38,0,0,1,1.14-.24,2,2,0,0,1,.94.24L38,25.78l1.12.63,5.32,3a1.16,1.16,0,0,1,.4.36.87.87,0,0,1,.16.49,1.12,1.12,0,0,1-.64,1l-1.15.56s-2.18,1-2.22,1l-1.61.67a2.42,2.42,0,0,1-1.15.24,2,2,0,0,1-.94-.25L34,31.5l-1.48-.87-4.83-2.84a1.37,1.37,0,0,1-.41-.38.87.87,0,0,1-.15-.47A1.14,1.14,0,0,1,27.73,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.74,26l1-.69c.07,0,2-1.26,2-1.23l.89-.49a2.37,2.37,0,0,1,1.11-.21,2.06,2.06,0,0,1,.92.25l4.13,2.32,1.1.62,5.24,2.94a1.34,1.34,0,0,1,.39.35,1,1,0,0,1,.17.48,1.12,1.12,0,0,1-.64,1L43,31.84c-.06,0-2.13,1-2.18,1l-1.59.61a2.43,2.43,0,0,1-1.12.2,2,2,0,0,1-.93-.25l-3.29-1.93-1.45-.86-4.75-2.79a1.23,1.23,0,0,1-.41-.37.84.84,0,0,1-.15-.46A1.08,1.08,0,0,1,27.74,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.75,26l1-.67a21.75,21.75,0,0,1,2-1.16l.87-.45a2.43,2.43,0,0,1,1.09-.17,2,2,0,0,1,.9.25l4.06,2.28,1.08.61L43.9,29.6a1.29,1.29,0,0,1,.39.34.89.89,0,0,1,.17.46,1.09,1.09,0,0,1-.62,1l-1.1.54a23,23,0,0,1-2.15.91L39,33.34a2.48,2.48,0,0,1-1.1.17,2.1,2.1,0,0,1-.9-.25l-3.24-1.91-1.43-.84-4.67-2.74a1.36,1.36,0,0,1-.4-.35.94.94,0,0,1-.16-.45A1.08,1.08,0,0,1,27.75,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.76,26.05l1-.65a19.67,19.67,0,0,1,2-1.1l.86-.4a2.46,2.46,0,0,1,1.06-.14,2.21,2.21,0,0,1,.88.25l4,2.25,1.06.59,5,2.84A1.37,1.37,0,0,1,44,30a.88.88,0,0,1,.18.46,1.06,1.06,0,0,1-.6.93l-1.08.52a15,15,0,0,1-2.12.86l-1.53.48a2.51,2.51,0,0,1-1.07.13,2.25,2.25,0,0,1-.89-.25l-3.18-1.87-1.4-.82-4.59-2.69a1.36,1.36,0,0,1-.4-.35.87.87,0,0,1-.16-.44A1,1,0,0,1,27.76,26.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M27.77,26.08l1-.63a14.08,14.08,0,0,1,1.94-1l.84-.36a2.73,2.73,0,0,1,1-.1,2.11,2.11,0,0,1,.86.25l3.91,2.2,1,.59,5,2.79a1.35,1.35,0,0,1,.38.32.85.85,0,0,1,.18.44,1,1,0,0,1-.59.91L42.25,32a14.15,14.15,0,0,1-2.08.81l-1.5.4a2.56,2.56,0,0,1-1.05.11,2.12,2.12,0,0,1-.86-.26l-3.13-1.83-1.38-.81-4.5-2.64a1.45,1.45,0,0,1-.39-.34.77.77,0,0,1-.17-.42A1,1,0,0,1,27.77,26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M27.78,26.12l1-.61a11.25,11.25,0,0,1,1.92-1l.83-.3a2.57,2.57,0,0,1,1-.08,2.24,2.24,0,0,1,.84.26l3.83,2.16,1,.57,4.87,2.75a1.39,1.39,0,0,1,.37.31.78.78,0,0,1,.18.42,1,1,0,0,1-.57.9L42,32a10.39,10.39,0,0,1-2,.76l-1.48.34a2.68,2.68,0,0,1-1,.07,2.24,2.24,0,0,1-.84-.26l-3.07-1.8-1.35-.79-4.43-2.59a1.5,1.5,0,0,1-.38-.32.82.82,0,0,1,.39-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M27.79,26.15l1-.59a8.57,8.57,0,0,1,1.89-.91l.81-.26a2.7,2.7,0,0,1,1-.05,2.1,2.1,0,0,1,.81.27L37,26.73l1,.56L42.79,30a1.57,1.57,0,0,1,.37.3.84.84,0,0,1,.18.41.92.92,0,0,1-.55.88l-1,.5a9,9,0,0,1-2,.71l-1.45.27a2.76,2.76,0,0,1-1,0,2.46,2.46,0,0,1-.83-.27l-3-1.76-1.33-.78L27.8,27.75a2,2,0,0,1-.38-.32.9.9,0,0,1-.18-.4A.93.93,0,0,1,27.79,26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M27.8,26.18l.94-.57a7.51,7.51,0,0,1,1.87-.85l.8-.21c.19-.11.72,0,1,0a2.45,2.45,0,0,1,.79.26l3.69,2.08,1,.56,4.68,2.64a1.48,1.48,0,0,1,.36.29.78.78,0,0,1,.19.4.89.89,0,0,1-.54.86l-1,.48a7.36,7.36,0,0,1-2,.67l-1.42.2c-.19.11-.73,0-1,0a2.29,2.29,0,0,1-.8-.27l-3-1.73-1.3-.76-4.26-2.48a1.47,1.47,0,0,1-.38-.31.83.83,0,0,1-.18-.38A.92.92,0,0,1,27.8,26.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M27.82,26.22l.92-.56c.22-.13,1.65-.89,1.84-.78l.78-.17c.18-.1.72,0,.94,0a2.34,2.34,0,0,1,.77.27l3.61,2,1,.54,4.58,2.59a2.64,2.64,0,0,1,.36.28.83.83,0,0,1,.19.39.85.85,0,0,1-.52.84l-1,.48a6.3,6.3,0,0,1-1.94.61L38,32.91c-.18.1-.73,0-1,0a2.47,2.47,0,0,1-.79-.28l-2.9-1.69L32,30.17l-4.18-2.44a1.76,1.76,0,0,1-.37-.29.83.83,0,0,1-.18-.38A.84.84,0,0,1,27.82,26.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M27.83,26.25l.91-.54c.24-.14,1.6-.84,1.81-.72l.77-.11c.16-.1.71.05.91.05a2.57,2.57,0,0,1,.75.27l3.54,2,.94.53L42,30.27a2,2,0,0,1,.36.27.87.87,0,0,1,.19.37.85.85,0,0,1-.5.83l-1,.47a5.52,5.52,0,0,1-1.91.56l-1.36.06c-.16.1-.72-.06-.93-.06a2.71,2.71,0,0,1-.77-.28l-2.84-1.65L32,30.11l-4.1-2.38a2.16,2.16,0,0,1-.37-.29,1,1,0,0,1-.19-.36A.84.84,0,0,1,27.83,26.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M27.84,26.28l.89-.52c.27-.16,1.56-.78,1.79-.65l.75-.07c.15-.09.71.08.89.08a2.57,2.57,0,0,1,.73.28l3.46,2,.93.52,4.4,2.48a3.35,3.35,0,0,1,.34.26.89.89,0,0,1,.21.36.83.83,0,0,1-.5.82l-.93.45a4.74,4.74,0,0,1-1.87.51H37.59c-.14.09-.72-.09-.9-.09a2.6,2.6,0,0,1-.75-.29l-2.79-1.62-1.23-.71-4-2.33a2.11,2.11,0,0,1-.36-.27.79.79,0,0,1-.2-.35A.81.81,0,0,1,27.84,26.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M27.85,26.31l.88-.5c.28-.17,1.51-.73,1.76-.59l.74,0c.13-.07.7.12.86.12a2.92,2.92,0,0,1,.71.28l3.39,1.91.9.51,4.31,2.44a2.3,2.3,0,0,1,.34.25.86.86,0,0,1,.21.35.79.79,0,0,1-.48.79l-.92.45a4.27,4.27,0,0,1-1.83.46l-1.31-.07c-.13.08-.72-.13-.88-.13a2.93,2.93,0,0,1-.73-.29l-2.73-1.58-1.2-.7-3.94-2.28a2.45,2.45,0,0,1-.35-.26.67.67,0,0,1-.2-.34A.78.78,0,0,1,27.85,26.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.86,26.35l.86-.49c.31-.18,1.48-.68,1.74-.52l.72,0c.12-.06.7.15.84.15a3.22,3.22,0,0,1,.69.28L36,27.67l.88.5,4.22,2.39a2.08,2.08,0,0,1,.34.24.8.8,0,0,1,.21.33.75.75,0,0,1-.46.78l-.9.43a3.7,3.7,0,0,1-1.8.42l-1.28-.14c-.11.06-.71-.16-.86-.16a3.36,3.36,0,0,1-.7-.3L33,30.62l-1.19-.69L28,27.7a2.22,2.22,0,0,1-.35-.25.89.89,0,0,1-.21-.32A.75.75,0,0,1,27.86,26.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M27.87,26.38l.85-.47c.33-.19,1.43-.62,1.71-.46l.71.07c.1-.05.69.18.81.18a3.29,3.29,0,0,1,.66.29l3.25,1.84.86.49,4.12,2.33a2.75,2.75,0,0,1,.33.23.8.8,0,0,1,.22.32.72.72,0,0,1-.45.76l-.87.43a3.21,3.21,0,0,1-1.77.36l-1.25-.2c-.09.05-.71-.2-.83-.2a3.27,3.27,0,0,1-.69-.3l-2.61-1.51-1.16-.66L28,27.7a2.93,2.93,0,0,1-.34-.24.89.89,0,0,1-.21-.32C27.36,26.88,27.52,26.59,27.87,26.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M27.88,26.41l.83-.45c.36-.2,1.39-.57,1.69-.39l.7.12c.08-.05.68.21.78.21a3.38,3.38,0,0,1,.64.29L35.69,28l.84.48,4,2.29.32.22a.71.71,0,0,1,.22.31c.07.25-.08.54-.43.74l-.85.41a2.92,2.92,0,0,1-1.74.32l-1.21-.27a7.3,7.3,0,0,1-.82-.23,4.07,4.07,0,0,1-.67-.31l-2.55-1.47-1.13-.65L28,27.69a2,2,0,0,1-.34-.23.59.59,0,0,1-.21-.3C27.38,26.9,27.53,26.62,27.88,26.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M27.9,26.45l.81-.44a2.56,2.56,0,0,1,1.66-.33l.68.17a6.59,6.59,0,0,1,.76.24,4.43,4.43,0,0,1,.62.3l3.1,1.75.82.47,3.94,2.23a3.53,3.53,0,0,1,.32.21.62.62,0,0,1,.22.3c.08.25-.07.52-.41.72l-.84.41a2.52,2.52,0,0,1-1.69.26L36.7,32.4a6.62,6.62,0,0,1-.79-.26,4.85,4.85,0,0,1-.65-.31l-2.5-1.43-1.11-.64L28,27.68a2.84,2.84,0,0,1-.34-.22.55.55,0,0,1-.21-.28C27.41,26.93,27.55,26.65,27.9,26.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M27.91,26.48l.8-.42a2.25,2.25,0,0,1,1.63-.26L31,26s.67.28.73.28a6.63,6.63,0,0,1,.6.29l3,1.72.8.45L40,30.94l.32.2a.57.57,0,0,1,.22.28c.08.24-.06.51-.4.71l-.81.4a2.35,2.35,0,0,1-1.66.21l-1.16-.41c-.05,0-.71-.29-.77-.29a5.33,5.33,0,0,1-.63-.32l-2.44-1.4L31.6,29.7l-3.54-2-.33-.21a.64.64,0,0,1-.22-.28C27.43,27,27.57,26.68,27.91,26.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M27.92,26.51l.78-.4a2.12,2.12,0,0,1,1.61-.2l.65.26s.67.31.71.31.55.29.58.3l3,1.68.78.44L39.73,31l.31.19a.53.53,0,0,1,.23.27c.09.24,0,.5-.38.69l-.79.39a2.15,2.15,0,0,1-1.63.17l-1.13-.48s-.7-.33-.74-.33a5.86,5.86,0,0,1-.61-.32L32.6,30.25l-1.06-.61-3.45-2a3.45,3.45,0,0,1-.32-.2.52.52,0,0,1-.23-.26C27.45,27,27.58,26.71,27.92,26.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M27.93,26.54l.77-.38A1.89,1.89,0,0,1,30.28,26l.64.31s.66.34.68.34.54.29.56.3L35,28.61l.76.44,3.67,2.08.3.18a.47.47,0,0,1,.23.26c.09.22,0,.48-.36.67l-.77.38a1.93,1.93,0,0,1-1.6.11l-1.1-.54s-.7-.36-.72-.36-.58-.32-.59-.33l-2.33-1.32-1-.59-3.37-1.93a3.37,3.37,0,0,1-.32-.19.5.5,0,0,1-.23-.25C27.47,27,27.6,26.74,27.93,26.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M37.05,32.73,32.44,30.1l-4.61-2.62c-.4-.23-.35-.64.11-.9l.75-.37a1.69,1.69,0,0,1,1.56-.06l4.61,2.62,4.62,2.62c.4.24.35.64-.12.9l-.75.37A1.73,1.73,0,0,1,37.05,32.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.69,1a1.18,1.18,0,0,1,1.13.07L38,5.75a4,4,0,0,1,1.66,3.18V30.64A1.52,1.52,0,0,1,39.09,32l-1.42.66C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.67,1a1.2,1.2,0,0,1,1.13.06L38,5.76a4,4,0,0,1,1.66,3.18V30.65A1.53,1.53,0,0,1,39.07,32l-1.4.65C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.65,1a1.24,1.24,0,0,1,1.13.07l8.15,4.71A4,4,0,0,1,39.59,9V30.66A1.5,1.5,0,0,1,39.05,32s-1.36.64-1.38.65C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.63,1a1.21,1.21,0,0,1,1.13.07l8.15,4.7A4,4,0,0,1,39.57,9V30.66A1.52,1.52,0,0,1,39,32l-1.36.64C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.61,1a1.18,1.18,0,0,1,1.13.07l8.15,4.7A4,4,0,0,1,39.55,9V30.67A1.52,1.52,0,0,1,39,32l-1.34.63C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.59,1a1.2,1.2,0,0,1,1.13.06l8.15,4.71A4,4,0,0,1,39.53,9V30.68A1.53,1.53,0,0,1,39,32l-1.32.62C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.57,1a1.24,1.24,0,0,1,1.13.07L37.85,5.8A4,4,0,0,1,39.51,9V30.69A1.5,1.5,0,0,1,39,32s-1.28.61-1.3.62C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.55,1a1.21,1.21,0,0,1,1.13.07l8.15,4.7A4,4,0,0,1,39.49,9V30.69A1.52,1.52,0,0,1,39,32l-1.28.61C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1L28.53,1a1.18,1.18,0,0,1,1.13.07l8.15,4.7A4,4,0,0,1,39.47,9V30.7A1.52,1.52,0,0,1,38.93,32l-1.26.6C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l1.07-.5a1.2,1.2,0,0,1,1.13.06l8.15,4.71A4,4,0,0,1,39.45,9V30.71A1.53,1.53,0,0,1,38.91,32l-1.24.59C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l1-.5a1.24,1.24,0,0,1,1.13.07l8.15,4.71A4,4,0,0,1,39.43,9v21.7A1.51,1.51,0,0,1,38.89,32s-1.2.58-1.22.59C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l1-.49a1.21,1.21,0,0,1,1.13.07l8.15,4.7A4,4,0,0,1,39.41,9V30.72a1.52,1.52,0,0,1-.54,1.33l-1.2.58C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l1-.48a1.2,1.2,0,0,1,1.13.06l8.15,4.71A4,4,0,0,1,39.39,9V30.73a1.52,1.52,0,0,1-.54,1.33l-1.18.57C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l1-.47a1.2,1.2,0,0,1,1.13.06l8.15,4.71A4,4,0,0,1,39.37,9V30.74a1.53,1.53,0,0,1-.54,1.33l-1.16.56C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l1-.47a1.24,1.24,0,0,1,1.13.07l8.15,4.71A4,4,0,0,1,39.35,9v21.7a1.51,1.51,0,0,1-.54,1.33s-1.12.55-1.14.56C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.95-.46a1.21,1.21,0,0,1,1.13.07l8.15,4.7A4,4,0,0,1,39.33,9V30.75a1.52,1.52,0,0,1-.54,1.33l-1.12.55C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.93-.45a1.2,1.2,0,0,1,1.13.06l8.15,4.71a4,4,0,0,1,1.66,3.18V30.76a1.52,1.52,0,0,1-.54,1.33l-1.1.54C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.91-.44a1.2,1.2,0,0,1,1.13.06l8.15,4.71a4,4,0,0,1,1.66,3.18V30.77a1.53,1.53,0,0,1-.54,1.33l-1.08.53C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.89-.44a1.24,1.24,0,0,1,1.13.07l8.15,4.71a4,4,0,0,1,1.66,3.18v21.7a1.51,1.51,0,0,1-.54,1.33l-1.06.53C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.87-.43a1.21,1.21,0,0,1,1.13.07l8.15,4.7a4,4,0,0,1,1.66,3.18V30.78a1.52,1.52,0,0,1-.54,1.33l-1,.52C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.85-.42a1.2,1.2,0,0,1,1.13.06L37.57,5.9a4,4,0,0,1,1.66,3.18V30.79a1.52,1.52,0,0,1-.54,1.33l-1,.51C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M37.45,32.13,29.3,27.42a4,4,0,0,1-1.66-3.18V2.53c0-.62-.52-.76-.2-1l.83-.41a1.2,1.2,0,0,1,1.13.06l8.15,4.71a4,4,0,0,1,1.66,3.18V30.8a1.53,1.53,0,0,1-.54,1.33l-1,.5C37.37,32.73,37.86,32.36,37.45,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M36.68,32.49l-8.16-4.7a4,4,0,0,1-1.66-3.18V2.9c0-1.23.74-1.79,1.66-1.26l8.16,4.71a4,4,0,0,1,1.66,3.18V31.24C38.34,32.46,37.59,33,36.68,32.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M37.34,32.53a1.15,1.15,0,0,1-.58-.18l-8.15-4.7a3.81,3.81,0,0,1-1.59-3V2.9c0-.79.33-1.29.84-1.29a1.23,1.23,0,0,1,.58.17l8.15,4.71a3.8,3.8,0,0,1,1.59,3V31.24C38.18,32,37.85,32.53,37.34,32.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M27.41,24.88V3.26c0-.9.55-1.31,1.22-.92l7.94,4.58a2.93,2.93,0,0,1,1.22,2.33V30.88c0,.9-.55,1.31-1.22.92l-7.94-4.58A3,3,0,0,1,27.41,24.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M28.72,2.57c-.63-.36-1.15-.07-1.15.66V25.1a2.53,2.53,0,0,0,1.15,2l7.76,4.48c.63.37,1.15.07,1.15-.66V9a2.56,2.56,0,0,0-1.15-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M39,16.66h0c-.24.14-.43,0-.43-.32V14.58a1,1,0,0,1,.43-.81h0c.23-.14.42,0,.42.32v1.76A1,1,0,0,1,39,16.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "33.32 5.33 35.02 6.31 31.75 10.02 31.19 14.71 29.57 16.82 28.44 19.44 27.74 21.15 27.74 17.99 28.56 15.85 29.81 14.33 30.36 12.16 31.28 9.3 33.32 5.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M37.54,13.16v-.27l-2.41-1.43V6.35l-.24-.14v5.12l-2.17-1.27L32,8.16l-4.3-2.45V6l1.12.29v7.44l-1.12-.65v.28l1.35.78V11l5.86,3.36v3.32L32.76,16.4h0l-2.21,2.39-2.86-1.63v.28l1.55.86v2.85L27.68,23v.26l1.64-1.94,2.48,4.22-2.34,1.81.22.13,4-2.77,1.25.71L36,31.08h.23L35.13,25.6l1.2.68V26l-1.21-.7V23l2.41,1.42V24.1l-2.41-1.42V18l2.41,1.42v-.27l-2.41-1.42V14.44l2.41,1.42v-.27l-2.41-1.42V11.74Zm-8.07,5.27,1,.58,0,0,2.21-2.38,0,0v4.64h0L29.47,21Zm5.42,6.76-1.27-.73-1.63,1-2.45-4.17,3.18.29.66.39h0l1.49.86Zm0-2.64L33,21.45V16.81l1.89,1.09Zm0-8.52L29,10.68V6.76l2.76,1.56.74,1.91,2.36,1.37Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "33.09 30.97 32.52 30.63 32.52 16.07 34.73 17.33 34.73 14.44 28.87 10.99 29.32 10.6 35.29 14.11 35.29 18.31 33.09 17.05 33.09 30.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M33,10.83c-1.69,1-4.66.7-4.66.7A3.26,3.26,0,0,1,30,8.77a3.3,3.3,0,0,1,3.4-.08C34.18,9.26,34.15,10.14,33,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M32.92,10.82c-1.66,1-4.61.7-4.61.7A3.31,3.31,0,0,1,30,8.79a3.25,3.25,0,0,1,3.36-.08C34.13,9.27,34.1,10.14,32.92,10.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M32.89,10.81c-1.65.95-4.56.7-4.56.7A3.3,3.3,0,0,1,30,8.81a3.2,3.2,0,0,1,3.31-.08C34.08,9.28,34,10.14,32.89,10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M32.85,10.8c-1.62.93-4.51.7-4.51.7A3.33,3.33,0,0,1,30,8.83a3.16,3.16,0,0,1,3.26-.08C34,9.29,34,10.14,32.85,10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M32.81,10.79a9.68,9.68,0,0,1-4.45.7A3.32,3.32,0,0,1,30,8.85a3.11,3.11,0,0,1,3.21-.08C34,9.3,33.93,10.14,32.81,10.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M32.77,10.77c-1.56.91-4.4.71-4.4.71A3.32,3.32,0,0,1,30,8.87a3.09,3.09,0,0,1,3.16-.08C33.91,9.31,33.87,10.14,32.77,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M32.73,10.76a9.55,9.55,0,0,1-4.34.71A3.35,3.35,0,0,1,30,8.89a3.06,3.06,0,0,1,3.12-.08C33.86,9.32,33.81,10.14,32.73,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M32.69,10.75a9.62,9.62,0,0,1-4.29.71A3.36,3.36,0,0,1,30,8.91a3,3,0,0,1,3.07-.08C33.81,9.33,33.75,10.14,32.69,10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M32.65,10.74a9.5,9.5,0,0,1-4.23.71A3.39,3.39,0,0,1,30,8.93a3,3,0,0,1,3-.08C33.75,9.34,33.7,10.14,32.65,10.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M32.61,10.73a9.58,9.58,0,0,1-4.18.71A3.41,3.41,0,0,1,30,9a2.91,2.91,0,0,1,3-.08C33.7,9.36,33.64,10.14,32.61,10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M32.58,10.72a9.67,9.67,0,0,1-4.13.71A3.42,3.42,0,0,1,30,9a2.84,2.84,0,0,1,2.91-.08C33.65,9.37,33.58,10.14,32.58,10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M32.54,10.71a9.61,9.61,0,0,1-4.08.71A3.42,3.42,0,0,1,30,9a2.8,2.8,0,0,1,2.86-.09C33.59,9.38,33.52,10.14,32.54,10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M32.5,10.7a9.66,9.66,0,0,1-4,.71A3.45,3.45,0,0,1,30,9a2.78,2.78,0,0,1,2.82-.09C33.54,9.39,33.47,10.14,32.5,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M32.46,10.68a9.48,9.48,0,0,1-4,.72A3.48,3.48,0,0,1,30.05,9,2.73,2.73,0,0,1,32.82,9C33.49,9.4,33.41,10.14,32.46,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M32.42,10.67a9.53,9.53,0,0,1-3.91.72,3.46,3.46,0,0,1,1.55-2.33A2.69,2.69,0,0,1,32.78,9C33.43,9.41,33.35,10.14,32.42,10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M32.38,10.66a9.66,9.66,0,0,1-3.86.72,3.53,3.53,0,0,1,1.55-2.3A2.64,2.64,0,0,1,32.74,9C33.38,9.42,33.3,10.13,32.38,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M32.34,10.65a9.54,9.54,0,0,1-3.8.72A3.51,3.51,0,0,1,30.08,9.1,2.6,2.6,0,0,1,32.7,9C33.33,9.43,33.24,10.13,32.34,10.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M32.3,10.64a9.65,9.65,0,0,1-3.75.72,3.61,3.61,0,0,1,1.53-2.24A2.57,2.57,0,0,1,32.66,9C33.27,9.45,33.18,10.13,32.3,10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M32.27,10.63a9.8,9.8,0,0,1-3.7.72,3.62,3.62,0,0,1,1.52-2.21,2.53,2.53,0,0,1,2.53-.09C33.22,9.46,33.12,10.13,32.27,10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M32.23,10.62a9.71,9.71,0,0,1-3.64.72A3.65,3.65,0,0,1,30.1,9.16a2.48,2.48,0,0,1,2.48-.09C33.17,9.47,33.07,10.13,32.23,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M32.19,10.61a9.84,9.84,0,0,1-3.59.72,3.7,3.7,0,0,1,1.51-2.15,2.44,2.44,0,0,1,2.43-.09C33.11,9.48,33,10.13,32.19,10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M32.15,10.6a10,10,0,0,1-3.53.72,3.68,3.68,0,0,1,1.5-2.12,2.39,2.39,0,0,1,2.38-.09C33.06,9.49,33,10.13,32.15,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M32.11,10.58a9.73,9.73,0,0,1-3.48.73,3.8,3.8,0,0,1,1.49-2.09,2.37,2.37,0,0,1,2.34-.09C33,9.5,32.9,10.13,32.11,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M32.07,10.57a9.88,9.88,0,0,1-3.42.73,3.75,3.75,0,0,1,1.48-2.05,2.3,2.3,0,0,1,2.29-.1C33,9.51,32.84,10.13,32.07,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M32,10.56a9.8,9.8,0,0,1-3.37.73,3.87,3.87,0,0,1,1.48-2,2.26,2.26,0,0,1,2.24-.1C32.9,9.52,32.78,10.13,32,10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M32,10.55a10,10,0,0,1-3.32.73,3.89,3.89,0,0,1,1.47-2,2.22,2.22,0,0,1,2.18-.1C32.84,9.53,32.72,10.13,32,10.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M32,10.54a10.22,10.22,0,0,1-3.27.73,4,4,0,0,1,1.47-2,2.18,2.18,0,0,1,2.13-.1C32.79,9.55,32.67,10.13,32,10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M31.92,10.53a10.15,10.15,0,0,1-3.21.73,4,4,0,0,1,1.45-1.93,2.12,2.12,0,0,1,2.09-.1C32.74,9.56,32.61,10.13,31.92,10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M31.88,10.52a10.37,10.37,0,0,1-3.16.73,4.16,4.16,0,0,1,1.45-1.9,2.08,2.08,0,0,1,2-.1C32.68,9.57,32.55,10.13,31.88,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M31.84,10.51a10.58,10.58,0,0,1-3.1.73,4.2,4.2,0,0,1,1.44-1.87,2,2,0,0,1,2-.1C32.63,9.58,32.5,10.13,31.84,10.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M31.8,10.49a10.29,10.29,0,0,1-3.05.74,4.24,4.24,0,0,1,1.44-1.84,2,2,0,0,1,1.94-.1C32.58,9.59,32.44,10.13,31.8,10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M31.76,10.48a10.58,10.58,0,0,1-3,.74A4.37,4.37,0,0,1,30.2,9.41a2,2,0,0,1,1.89-.1C32.52,9.6,32.38,10.13,31.76,10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M31.72,10.47a10.88,10.88,0,0,1-2.94.74,4.49,4.49,0,0,1,1.43-1.78,1.93,1.93,0,0,1,1.84-.1C32.47,9.61,32.32,10.13,31.72,10.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M29.43,5.64A3.19,3.19,0,0,1,28,3.14a1.15,1.15,0,0,1,.27-.82l-.31.13c-.39.07-.64.43-.64,1A3.21,3.21,0,0,0,28.75,6a1,1,0,0,0,1.09,0,3.14,3.14,0,0,0,.31-.18A1.24,1.24,0,0,1,29.43,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M29.58.41A2.05,2.05,0,0,0,27.34.27l-.64.3.08.41a2.81,2.81,0,0,0-.22,1.15A16.63,16.63,0,0,0,28,7.3l.76,4,.83-.41s3-2.5,3-5.22A6.65,6.65,0,0,0,29.58.41ZM28.75,6a3.21,3.21,0,0,1-1.45-2.5c0-.92.65-1.29,1.45-.83a3.19,3.19,0,0,1,1.45,2.5C30.2,6.05,29.55,6.42,28.75,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M28.75.83c-1.67-1-3-.19-3,1.72,0,2.72,3,8.7,3,8.7s3-2.49,3-5.21A6.66,6.66,0,0,0,28.75.83Zm0,5.13a3.21,3.21,0,0,1-1.45-2.5c0-.92.65-1.29,1.45-.83a3.19,3.19,0,0,1,1.45,2.5C30.2,6.05,29.55,6.42,28.75,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M28.94.73A2.07,2.07,0,0,0,26.73.56a2.19,2.19,0,0,1,2,.27,6.66,6.66,0,0,1,3,5.21c0,2.33-2.22,4.49-2.85,5.07l0,0s3-2.5,3-5.22A6.63,6.63,0,0,0,28.94.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M28.83,5.93a3.19,3.19,0,0,1-1.45-2.5,1,1,0,0,1,.41-.92,1,1,0,0,0-.51,1A3.19,3.19,0,0,0,28.73,6a1,1,0,0,0,1,.1A1.09,1.09,0,0,1,28.83,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.38,33.37l7.22-4.15c.62-.36.54-1-.17-1.4L10.05,18.71a2.64,2.64,0,0,0-2.41-.1L.42,22.76c-.62.36-.54,1,.17,1.39L16,33.27A2.67,2.67,0,0,0,18.38,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M.54,22.82a.76.76,0,0,0-.39.47c-.06.29.13.61.56.86l15.24,9a2.66,2.66,0,0,0,1.28.34,2.3,2.3,0,0,0,.93-.16l.17-.08,7.12-4.1a.74.74,0,0,0,.39-.46c.06-.29-.13-.62-.56-.87L10,18.82a2.73,2.73,0,0,0-1.27-.33,2.27,2.27,0,0,0-.93.15l-.17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M.65,22.89a.71.71,0,0,0-.37.44c-.05.27.13.58.54.82l15.12,9a2.81,2.81,0,0,0,1.26.33,2.38,2.38,0,0,0,.91-.16l.16-.08,7-4a.72.72,0,0,0,.37-.45c0-.27-.12-.58-.54-.82L10,18.94a2.61,2.61,0,0,0-1.25-.33,2.07,2.07,0,0,0-.92.16l-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M.77,23a.67.67,0,0,0-.35.42c0,.25.12.55.52.78l15,8.89a2.68,2.68,0,0,0,1.23.32,2.1,2.1,0,0,0,.9-.16l.16-.08,6.93-4a.67.67,0,0,0,.35-.42c.05-.25-.12-.55-.52-.78L10,19.05a2.68,2.68,0,0,0-1.23-.32,2.13,2.13,0,0,0-.9.16L7.7,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M.89,23a.58.58,0,0,0-.33.4c0,.23.11.5.5.72L15.92,33a2.68,2.68,0,0,0,1.21.31,2.16,2.16,0,0,0,.88-.16l.16-.08L25,29.11a.58.58,0,0,0,.33-.4c0-.23-.11-.51-.5-.73L10,19.16a2.56,2.56,0,0,0-1.21-.31,2,2,0,0,0-.88.16l-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1,23.08a.61.61,0,0,0-.32.38c0,.21.12.47.48.68l14.74,8.75a2.56,2.56,0,0,0,1.19.31A2.06,2.06,0,0,0,18,33l.15-.07,6.74-3.88a.6.6,0,0,0,.32-.37c0-.21-.12-.48-.48-.69L10,19.28A2.48,2.48,0,0,0,8.76,19a2.06,2.06,0,0,0-.86.16l-.15.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1.12,23.15a.55.55,0,0,0-.29.35c0,.19.11.44.46.64l14.6,8.67a2.42,2.42,0,0,0,1.17.3,1.82,1.82,0,0,0,.85-.16l.15-.08,6.64-3.81a.58.58,0,0,0,.3-.36c0-.19-.11-.44-.46-.64L9.93,19.39a2.48,2.48,0,0,0-1.17-.3,2,2,0,0,0-.85.16l-.14.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1.24,23.21a.55.55,0,0,0-.28.34c0,.17.11.4.44.59l14.48,8.6A2.42,2.42,0,0,0,17,33a2,2,0,0,0,.84-.17l.13-.07L24.55,29a.52.52,0,0,0,.28-.34c0-.17-.11-.4-.44-.59L9.91,19.5a2.51,2.51,0,0,0-1.15-.29,1.89,1.89,0,0,0-.83.17l-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1.36,23.28c-.12.07-.25.18-.26.31s.1.36.42.55l14.35,8.52A2.43,2.43,0,0,0,17,33a1.87,1.87,0,0,0,.82-.17l.13-.07L24.4,29c.12-.07.25-.18.26-.31s-.1-.37-.42-.55L9.89,19.62a2.42,2.42,0,0,0-1.12-.29A1.81,1.81,0,0,0,8,19.5l-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1.48,23.34c-.11.06-.24.17-.24.29s.1.33.4.5l14.22,8.46a2.3,2.3,0,0,0,1.1.27,1.65,1.65,0,0,0,.81-.17l.12-.06L24.25,29c.11-.06.24-.16.24-.29s-.1-.32-.4-.5L9.87,19.73a2.19,2.19,0,0,0-1.1-.28,1.77,1.77,0,0,0-.81.17l-.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1.59,23.41c-.09.05-.21.15-.22.26s.1.3.38.46l14.1,8.38a2.22,2.22,0,0,0,1.08.27,1.68,1.68,0,0,0,.79-.17l.12-.07L24.1,29c.1-.06.22-.15.23-.27s-.1-.29-.38-.46L9.85,19.84a2.24,2.24,0,0,0-1.08-.27,1.68,1.68,0,0,0-.79.17l-.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M16.9,32.7a1.6,1.6,0,0,0,.77-.17L24,28.92c.08-.05.21-.14.21-.25s-.1-.25-.36-.41L9.83,20a2.14,2.14,0,0,0-1.06-.27,1.56,1.56,0,0,0-.77.18l-6.29,3.6c-.08.05-.2.14-.2.25s.09.26.36.41l14,8.3A2.11,2.11,0,0,0,16.9,32.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M3.56,15.32,7.19,17.1l6.43-3.68-3.06-1.64a.48.48,0,0,0-.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1.79,19.74v2.55l5.4,3.3V17.1L4.07,15.31a.48.48,0,0,0-.69.21L2.15,18.11A3.84,3.84,0,0,0,1.79,19.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "7.19 17.09 7.19 25.59 13.62 21.88 13.62 13.41 7.19 17.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M5.65,20.1l.37.21a.28.28,0,0,1,.13.23v0a.12.12,0,0,1-.18.1l-.33-.19a.25.25,0,0,1-.13-.22v-.07A.09.09,0,0,1,5.65,20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M5.64,20.47l.33.19a.12.12,0,0,0,.18-.09h0v.06a.12.12,0,0,1-.18.11l-.33-.2a.25.25,0,0,1-.13-.22v-.08A.25.25,0,0,0,5.64,20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M4,16a.34.34,0,0,0-.48.15l-.73,1.58a.34.34,0,0,0,.14.43l3.27,1.88a.23.23,0,0,0,.35-.2v-2a.46.46,0,0,0-.24-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M6.29,20l-.06,0L3,18.06a.21.21,0,0,1-.09-.27l.73-1.58a.2.2,0,0,1,.31-.09L6.22,17.5a.35.35,0,0,1,.18.31v2a.12.12,0,0,1,0,.08S6.32,20,6.29,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M3.75,19.1a.05.05,0,0,0,0,0,.08.08,0,0,0,0-.08l-.4-.24a.7.7,0,0,1-.33-.59V16.62A.69.69,0,0,1,3.36,16l.38-.26a.05.05,0,0,0,0-.08.06.06,0,0,0-.08,0l-.39.25a.85.85,0,0,0-.36.68v1.54a.81.81,0,0,0,.39.69l.4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M2.74,18.24,3,18.08a.54.54,0,0,0,.22-.43v-.84c0-.17-.1-.24-.22-.17l-.28.16a.54.54,0,0,0-.22.43v.85C2.52,18.24,2.62,18.32,2.74,18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M2.74,16.8,3,16.64a.15.15,0,0,1,.18,0,.19.19,0,0,0-.1,0l-.28.16a.52.52,0,0,0-.23.43v.84a.23.23,0,0,0,.05.16c-.07,0-.12-.08-.12-.19v-.85A.54.54,0,0,1,2.74,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M3,22.61v.89l-1.49-.94a.21.21,0,0,1-.1-.17v-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1.78,21.55v-.26a.33.33,0,0,1-.11.06c-.38.19-.27.29,0,.44L3,22.61l.24-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "2.48 21.66 2.48 23.41 3.43 22.88 3.36 21.13 2.48 21.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M6.71,24.24a1.16,1.16,0,0,1-.46,1.05l-.87.5c-.29.17-.11-.21-.56-.47a3.63,3.63,0,0,1-1.64-2.83c0-.52-.47-.52-.18-.69l.92-.51a1.19,1.19,0,0,1,1.15.12A3.61,3.61,0,0,1,6.71,24.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-120",
    cx: 4.16,
    cy: 23.81,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-11.45 5.35) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-121",
    cx: 4.16,
    cy: 23.81,
    rx: 0.95,
    ry: 1.65,
    transform: "matrix(0.86, -0.5, 0.5, 0.86, -11.45, 5.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M5.33,24.49a1,1,0,0,1-.15.57.75.75,0,0,1-.82,0,2.41,2.41,0,0,1-1.09-1.88c0-.5.26-.79.63-.78l.26.12A2.57,2.57,0,0,1,5.33,24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M3.49,22.33a.8.8,0,0,0-.34.74,2.58,2.58,0,0,0,1.17,2,.93.93,0,0,0,.67.15.85.85,0,0,1-.83-.08,2.58,2.58,0,0,1-1.17-2C3,22.68,3.19,22.39,3.49,22.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M4.6,24c0,.19-.13.27-.3.17A.67.67,0,0,1,4,23.64c0-.19.14-.27.31-.17A.66.66,0,0,1,4.6,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M4.24,21.89a1.2,1.2,0,0,0-1.12-.14,1.3,1.3,0,0,1,1,.2,3.63,3.63,0,0,1,1.64,2.83,1.11,1.11,0,0,1-.52,1.07c.4-.11.66-.51.66-1.13A3.63,3.63,0,0,0,4.24,21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M4.17,22.81a.32.32,0,0,0,.16.26c.08.05.15,0,.15-.09a.35.35,0,0,0-.15-.26C4.24,22.67,4.17,22.71,4.17,22.81Zm0,1.79a.32.32,0,0,0,.16.26c.08.05.15,0,.15-.09a.35.35,0,0,0-.15-.26C4.24,24.46,4.17,24.5,4.17,24.6Zm-.29-1.82c-.06-.1-.15-.16-.21-.13s-.06.15,0,.25.15.16.21.13S3.94,22.88,3.88,22.78Zm.89,2c.06.11.16.16.22.13s.06-.15,0-.25-.16-.16-.22-.12S4.71,24.7,4.77,24.8ZM3.39,23.25a.34.34,0,0,0,.16.27c.08.05.15,0,.15-.09a.32.32,0,0,0-.15-.26C3.46,23.12,3.39,23.16,3.39,23.25Zm1.56.9a.34.34,0,0,0,.16.27c.08,0,.15,0,.15-.09a.34.34,0,0,0-.15-.26C5,24,5,24.06,5,24.15Zm-1.28,0c.06.1.15.16.21.12s.06-.14,0-.25-.15-.15-.21-.12S3.61,24.06,3.67,24.17Zm1.1-.63c.06.1.16.16.22.12s.06-.14,0-.24-.16-.16-.22-.13S4.71,23.44,4.77,23.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M4.8,24a.29.29,0,0,1-.13.28l-.19.12c-.08,0,0-.06-.15-.13a1,1,0,0,1-.45-.78c0-.14-.14-.15-.06-.19L4,23.18a.35.35,0,0,1,.32,0A1,1,0,0,1,4.8,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M4.6,24.11c0,.29-.21.41-.46.26a1,1,0,0,1-.45-.78c0-.28.2-.4.45-.26A1,1,0,0,1,4.6,24.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "6.22 25.36 6.22 23.81 5.04 21.79 3.38 20.83 4.38 20.26 6.05 21.22 7.22 23.25 7.22 24.79 6.22 25.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "6.22 23.81 5.04 21.79 6.05 21.22 7.22 23.25 6.22 23.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "5.94 25.21 5.94 23.89 4.84 21.99 3.38 21.14 2.48 21.66 2.48 23.41 2.2 23.25 2.2 21.5 3.38 20.82 5.04 21.79 6.22 23.81 6.22 25.37 5.94 25.21"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "6.19 23.78 5.01 21.75 3.37 20.8 3.43 20.77 5.1 21.73 6.27 23.76 6.27 25.32 6.19 25.27 6.19 23.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "2.45 23.3 2.45 21.62 3.35 21.11 3.37 21.12 2.54 21.6 2.54 23.35 2.45 23.3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-134",
    cx: 5.11,
    cy: 21.65,
    rx: 1.12,
    ry: 2.09,
    transform: "translate(-13.72 9.8) rotate(-44.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "1.79 20.41 1.79 21.23 2.04 21.37 2.04 20.56 1.79 20.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "1.79 21.23 2.04 21.37 2.04 20.72 1.79 21.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "1.79 21.15 1.79 21.23 2.04 21.37 2.04 21.3 1.79 21.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1.8,21c0,.07.06.1.12.05A.26.26,0,0,0,2,20.86c0-.08-.06-.1-.13-.06A.26.26,0,0,0,1.8,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1.46,21.66c.23.09.54-.12.69-.47s.09-.73-.14-.83-.54.12-.69.47S1.23,21.56,1.46,21.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "13.51 27.23 13.51 28.79 8.25 25.74 8.25 24.19 13.51 27.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "13.5 27.23 13.5 28.79 14.98 27.95 14.98 26.39 13.5 27.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "14.98 26.39 13.5 27.23 8.25 24.19 9.73 23.35 14.98 26.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "12.64 28.53 12.37 28.69 8.01 26.18 8.28 26.02 12.64 28.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "8 24.58 8 26.18 8.28 26.02 8.28 24.42 8 24.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M7.61,24.14v2.25l5.16,3V27.11Zm.4.69,4.36,2.51v1.35L8,26.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "12.77 27.11 12.77 29.39 13.1 29.21 13.1 26.93 12.77 27.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "13.1 26.93 12.77 27.11 7.61 24.14 7.95 23.96 13.1 26.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "14.04 26.99 14.04 29.95 14.55 29.66 14.55 26.69 14.04 26.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M18.41,30.9a1.14,1.14,0,0,1-.45,1l-.91.53c-.29.16-.11-.21-.55-.47a3.6,3.6,0,0,1-1.63-2.82c0-.51-.48-.51-.19-.68l1-.53a1.17,1.17,0,0,1,1.14.12A3.6,3.6,0,0,1,18.41,30.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-150",
    cx: 15.84,
    cy: 30.49,
    rx: 1.33,
    ry: 2.3,
    transform: "translate(-13.22 12.16) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M15.91,28.58a1.18,1.18,0,0,0-1.11-.14,1.27,1.27,0,0,1,1,.2,3.61,3.61,0,0,1,1.64,2.81,1.11,1.11,0,0,1-.52,1.07,1,1,0,0,0,.66-1.12A3.58,3.58,0,0,0,15.91,28.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M15.82,29.36c-.58-.33-1.05-.06-1.05.6a2.32,2.32,0,0,0,1.05,1.82c.58.34,1.06.07,1.06-.6A2.36,2.36,0,0,0,15.82,29.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M16.2,31.54a2.33,2.33,0,0,1-1.06-1.82.89.89,0,0,1,.13-.49c-.3,0-.5.3-.5.73a2.32,2.32,0,0,0,1.05,1.82c.41.24.76.18.93-.1A.87.87,0,0,1,16.2,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M16.55,31.09c0,.41-.29.58-.65.37a1.43,1.43,0,0,1-.65-1.12c0-.41.29-.58.65-.37A1.42,1.42,0,0,1,16.55,31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M16.5,30.85c0,.35-.24.49-.55.32a1.23,1.23,0,0,1-.55-1c0-.35.25-.49.55-.32A1.2,1.2,0,0,1,16.5,30.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M16.35,31c0,.35-.24.49-.55.31a1.21,1.21,0,0,1-.55-.95c0-.35.25-.49.55-.31A1.19,1.19,0,0,1,16.35,31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "18.3 29.43 18.3 32.39 17.77 32.09 17.77 29.73 14.04 27.59 14.04 29.95 13.52 29.64 13.52 26.68 18.3 29.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "18.3 29.44 18.3 32.4 18.82 32.11 18.82 29.14 18.3 29.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "19.03 29.87 19.03 31.85 18.83 31.7 18.83 29.72 19.03 29.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "19.03 29.87 19.03 31.85 25.36 28.22 25.36 26.23 19.03 29.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "25.36 26.23 19.03 29.87 18.83 29.72 25.16 26.08 25.36 26.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "18.81 29.31 18.81 31.44 18.6 31.27 18.6 29.15 18.81 29.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "18.81 29.31 18.81 31.44 25.59 27.54 25.59 25.41 18.81 29.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "25.59 25.41 18.81 29.31 18.6 29.15 25.39 25.25 25.59 25.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "18.91 22.19 18.91 30.45 7.57 23.84 7.57 15.61 18.91 22.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "18.33 22.53 8.15 16.62 8.15 23.5 18.33 29.44 18.33 22.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "18.33 22.53 18.33 23.14 8.36 17.34 8.36 23.62 8.15 23.5 8.15 16.62 18.33 22.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "18.91 22.19 18.91 30.45 25.63 26.62 25.63 18.35 18.91 22.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "25.05 26.28 25.05 19.35 19.49 22.53 19.49 29.45 25.05 26.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "25.63 18.35 18.91 22.19 7.57 15.61 14.3 11.77 25.63 18.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "19.49 23.06 25.04 26.29 25.05 26.28 25.05 19.35 19.49 22.53 19.49 23.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M23.66,28.46v-.19a.27.27,0,0,0-.4-.23l-1.74,1a.85.85,0,0,0-.43.75v.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "21.58 29.19 21.58 29.66 23.26 28.71 23.26 28.23 21.58 29.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "23.26 28.23 23.26 28.3 21.64 29.23 21.64 29.62 21.58 29.66 21.58 29.19 23.26 28.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "24.46 27.43 24.46 27.89 25.52 27.28 25.52 26.82 24.46 27.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "24.99 27.13 24.99 27.59 25.52 27.28 25.52 26.82 24.99 27.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M24.82,27.42l-.14.3s-.21-.18-.17-.27S24.82,27.42,24.82,27.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M24.63,27.63a.08.08,0,0,0,.12.07.28.28,0,0,0,.12-.2c0-.08-.06-.11-.12-.07A.28.28,0,0,0,24.63,27.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M25.4,27.08l-.13.29s-.21-.18-.17-.26S25.4,27.08,25.4,27.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M25.22,27.28c0,.08.05.11.12.07a.27.27,0,0,0,.11-.2c0-.07-.05-.1-.11-.07A.25.25,0,0,0,25.22,27.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M24.62,27.58c.1.22.51.26.93.07s.68-.51.58-.73-.51-.25-.93-.07S24.52,27.36,24.62,27.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "18.84 30.64 18.84 31.1 19.9 30.49 19.9 30.04 18.84 30.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "19.37 30.34 19.37 30.8 19.9 30.49 19.9 30.04 19.37 30.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M19.19,30.63l-.13.3s-.21-.18-.17-.27S19.19,30.63,19.19,30.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M19,30.84c0,.08,0,.1.12.07a.27.27,0,0,0,.11-.2c0-.08,0-.11-.11-.07A.25.25,0,0,0,19,30.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M19.78,30.29l-.14.29s-.21-.18-.16-.26S19.78,30.29,19.78,30.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M19.6,30.49c0,.08,0,.11.11.07a.25.25,0,0,0,.12-.2c0-.07,0-.1-.12-.07A.27.27,0,0,0,19.6,30.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M18.79,30.91c.09.22.51.26.93.07s.67-.51.58-.73-.52-.25-.94-.07S18.69,30.69,18.79,30.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "20.34 24.15 20.34 26.68 22.78 25.27 22.78 22.72 20.34 24.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "20.35 24.15 20.35 26.68 18.04 25.34 18.04 22.8 20.35 24.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "18.04 22.8 20.35 24.15 22.78 22.72 20.46 21.37 18.04 22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "18.04 22.8 20.35 24.15 22.78 22.72 20.35 24.11 18.04 22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "21.38 23.56 21.38 24.23 21.93 23.92 21.93 23.22 21.38 23.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "19.07 22.2 21.38 23.56 21.93 23.22 19.61 21.87 19.07 22.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "20.81 25.07 20.61 25.67 20.74 25.6 20.74 26.31 20.88 26.23 20.88 25.52 21 25.45 20.81 25.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "21.47 25.18 21.28 24.8 21.08 25.4 21.21 25.32 21.21 26.04 21.34 25.96 21.34 25.25 21.47 25.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "17.24 22.32 19.55 23.68 21.98 22.25 19.67 20.9 17.24 22.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "22.74 25.44 22.74 27.05 24.29 26.15 24.29 24.53 22.74 25.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "22.74 25.44 22.74 27.05 21.27 26.2 21.27 24.58 22.74 25.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "21.27 24.58 22.74 25.44 24.29 24.53 22.81 23.67 21.27 24.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "21.27 24.58 22.74 25.44 24.29 24.53 22.74 25.42 21.27 24.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "23.39 25.06 23.39 25.49 23.75 25.29 23.75 24.85 23.39 25.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "21.93 24.2 23.4 25.06 23.75 24.85 22.27 23.99 21.93 24.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "23.03 26.02 22.91 26.41 22.99 26.36 22.99 26.81 23.07 26.76 23.07 26.31 23.16 26.26 23.03 26.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "23.45 26.09 23.33 25.85 23.21 26.23 23.29 26.19 23.29 26.64 23.37 26.59 23.37 26.14 23.45 26.09"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M16,25.69a2.4,2.4,0,0,1-1.09-1.88c0-.69.49-1,1.09-.62a2.41,2.41,0,0,1,1.09,1.88C17.06,25.76,16.57,26,16,25.69Zm0-2.25c-.48-.28-.87-.06-.87.5a1.91,1.91,0,0,0,.87,1.5c.49.28.88.06.88-.49A1.91,1.91,0,0,0,16,23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M16.63,25l-.76-.44v-.94c0-.07,0-.1.1-.06a.22.22,0,0,1,.11.18v.69l.55.32a.25.25,0,0,1,.11.19C16.74,25,16.69,25,16.63,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.9,24.08s-.07.27-.27.33a.44.44,0,0,1-.43-.12s.18.06.32-.21a2,2,0,0,0,0-1.27s-.19.75-.76.42c-.36-.21-.81-.34-1-.22a1,1,0,0,1,.21.1,2.55,2.55,0,0,1,1.17,2,1.14,1.14,0,0,1-.06.39,1.26,1.26,0,0,0,.65-.36C18,24.85,17.9,24.08,17.9,24.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "17.98 23.32 17.07 22.57 17.98 23.09 17.98 23.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "17.98 23.37 16.9 22.47 17.07 22.57 17.98 23.32 17.98 23.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "17.98 23.41 16.73 22.38 16.9 22.47 17.98 23.37 17.98 23.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "17.98 23.45 16.56 22.28 16.73 22.38 17.98 23.41 17.98 23.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "17.98 23.5 16.39 22.18 16.56 22.28 17.98 23.45 17.98 23.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "17.98 23.54 16.22 22.08 16.39 22.18 17.98 23.5 17.98 23.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "17.98 23.59 16.05 21.98 16.22 22.08 17.98 23.54 17.98 23.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "17.98 23.63 15.88 21.88 16.05 21.98 17.98 23.59 17.98 23.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "17.98 23.67 15.84 21.89 15.85 21.86 15.88 21.88 17.98 23.63 17.98 23.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "17.98 23.72 15.83 21.93 15.84 21.89 17.98 23.67 17.98 23.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "17.98 23.76 15.82 21.97 15.83 21.93 17.98 23.72 17.98 23.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "17.98 23.8 15.82 22 15.82 21.97 17.98 23.76 17.98 23.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "17.98 23.85 15.81 22.04 15.82 22 17.98 23.8 17.98 23.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "17.98 23.89 15.8 22.08 15.81 22.04 17.98 23.85 17.98 23.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "17.98 23.94 15.79 22.11 15.8 22.08 17.98 23.89 17.98 23.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "17.98 23.98 15.78 22.15 15.79 22.11 17.98 23.94 17.98 23.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "17.98 24.02 15.78 22.19 15.78 22.15 17.98 23.98 17.98 24.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "17.98 24.07 15.77 22.23 15.78 22.19 17.98 24.02 17.98 24.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "17.98 24.11 15.76 22.26 15.76 22.25 15.77 22.23 17.98 24.07 17.98 24.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "17.98 24.16 15.76 22.31 15.76 22.26 17.98 24.11 17.98 24.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "17.98 24.2 15.76 22.35 15.76 22.31 17.98 24.16 17.98 24.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "17.98 24.24 15.76 22.39 15.76 22.35 17.98 24.2 17.98 24.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "17.98 24.29 15.76 22.44 15.76 22.39 17.98 24.24 17.98 24.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "17.98 24.33 15.76 22.48 15.76 22.44 17.98 24.29 17.98 24.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "17.98 24.37 15.76 22.53 15.76 22.48 17.98 24.33 17.98 24.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "17.98 24.42 15.76 22.57 15.76 22.53 17.98 24.37 17.98 24.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "17.98 24.46 15.76 22.61 15.76 22.57 17.98 24.42 17.98 24.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "17.98 24.5 15.76 22.66 15.76 22.61 17.98 24.46 17.98 24.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "17.98 24.55 15.76 22.7 15.76 22.66 17.98 24.5 17.98 24.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "17.98 24.59 15.76 22.75 15.76 22.7 17.98 24.55 17.98 24.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "17.98 24.64 15.76 22.79 15.76 22.75 17.98 24.59 17.98 24.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "17.98 24.68 15.76 22.83 15.76 22.79 17.98 24.64 17.98 24.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "17.98 24.72 15.76 22.88 15.76 22.83 17.98 24.68 17.98 24.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "17.98 24.77 15.76 22.92 15.76 22.88 17.98 24.72 17.98 24.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "17.98 24.81 15.76 22.96 15.76 22.92 17.98 24.77 17.98 24.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "17.98 24.86 15.76 23.01 15.76 22.96 17.98 24.81 17.98 24.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "17.98 24.9 15.76 23.05 15.76 23.01 17.98 24.86 17.98 24.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "17.98 24.94 15.76 23.09 15.76 23.05 17.98 24.9 17.98 24.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "17.98 24.99 15.76 23.14 15.76 23.09 17.98 24.94 17.98 24.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "17.98 25.03 15.76 23.18 15.76 23.14 17.98 24.99 17.98 25.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "17.98 25.07 15.76 23.23 15.76 23.18 17.98 25.03 17.98 25.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "17.98 25.12 15.76 23.27 15.76 23.23 17.98 25.07 17.98 25.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "17.98 25.16 15.76 23.31 15.76 23.27 17.98 25.12 17.98 25.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "17.98 25.2 15.76 23.36 15.76 23.31 17.98 25.16 17.98 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "17.98 25.25 15.76 23.4 15.76 23.36 17.98 25.2 17.98 25.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "17.98 25.29 15.76 23.44 15.76 23.4 17.98 25.25 17.98 25.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "17.98 25.34 15.76 23.49 15.76 23.44 17.98 25.29 17.98 25.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "17.98 25.38 15.76 23.53 15.76 23.49 17.98 25.34 17.98 25.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "17.98 25.42 15.76 23.58 15.76 23.53 17.98 25.38 17.98 25.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "17.98 25.47 15.76 23.62 15.76 23.58 17.98 25.42 17.98 25.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "17.98 25.51 15.76 23.66 15.76 23.62 17.98 25.47 17.98 25.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "17.98 25.55 15.76 23.71 15.76 23.66 17.98 25.51 17.98 25.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "17.98 25.6 15.76 23.75 15.76 23.71 17.98 25.55 17.98 25.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "17.98 25.6 17.97 25.64 15.76 23.79 15.76 23.75 17.98 25.6 17.98 25.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "17.97 25.64 17.96 25.67 15.76 23.84 15.76 23.79 17.97 25.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "17.96 25.67 17.95 25.71 15.76 23.88 15.76 23.84 17.96 25.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "17.95 25.71 17.94 25.75 15.76 23.93 15.76 23.88 17.95 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "17.94 25.75 17.94 25.78 15.76 23.97 15.76 23.93 17.94 25.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "17.94 25.78 17.93 25.82 15.76 24.01 15.76 23.97 17.94 25.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "17.93 25.82 17.92 25.86 15.76 24.06 15.76 24.01 17.93 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "17.92 25.86 17.91 25.89 15.76 24.1 15.76 24.06 17.92 25.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "17.91 25.89 17.9 25.93 15.76 24.14 15.76 24.1 17.91 25.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "17.9 25.93 17.89 25.97 15.76 24.19 15.76 24.14 17.9 25.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "17.89 25.97 17.89 25.98 17.76 25.9 15.76 24.23 15.76 24.19 17.89 25.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-272",
    points: "17.59 25.8 15.76 24.27 15.76 24.23 17.76 25.9 17.59 25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "17.42 25.7 15.76 24.32 15.76 24.27 17.59 25.8 17.42 25.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "17.25 25.6 15.76 24.36 15.76 24.32 17.42 25.7 17.25 25.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "17.08 25.5 15.76 24.41 15.76 24.36 17.25 25.6 17.08 25.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "15.76 24.41 17.08 25.5 15.76 24.75 15.76 24.41"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M9.05,19.41l.34.2a.6.6,0,0,1,.25.25.64.64,0,0,1,.09.34V21c0,.13,0,.21-.09.25a.27.27,0,0,1-.25,0L9.05,21ZM9.39,21s.06,0,.08,0,0,0,0-.1v-.85a.25.25,0,0,0,0-.13.18.18,0,0,0-.08-.09l-.11-.07v1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M9.88,19.89l.6.35v.23l-.38-.22v.43l.3.18v.23l-.3-.18v.5l.38.22v.24l-.6-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M10.61,20.31l.22.13v1.4l.37.21v.23l-.59-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M11.31,20.71l.22.13v1.63l-.22-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M11.64,20.91l.22.13L12,22.38h0l.15-1.17.2.11-.21,1.51-.3-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M12.47,21.39l.61.35V22l-.39-.22v.43l.31.17v.24l-.31-.18v.5l.39.22v.23L12.47,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M13.21,21.81l.33.19a.82.82,0,0,1,.25.24.67.67,0,0,1,.08.33v.1c0,.17,0,.24-.15.23h0a.42.42,0,0,1,.11.18.62.62,0,0,1,0,.25v.4a.29.29,0,0,0,0,.09l-.22-.13a.31.31,0,0,1,0-.08s0-.07,0-.13v-.3a.4.4,0,0,0,0-.17.26.26,0,0,0-.1-.11l-.08,0v.7l-.22-.13Zm.3.87s.08,0,.1,0,0-.05,0-.11v-.13a.52.52,0,0,0,0-.14.2.2,0,0,0-.09-.09l-.1-.06v.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M14.19,23.32l-.27-1.09.24.13.15.69h0l.15-.51.22.13-.27.77v.7L14.19,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M34.75,23.66a8.38,8.38,0,0,0-1.38.81,6.81,6.81,0,0,1-.72.4s-.27-.08-.34-.05a.34.34,0,0,0-.15.1.22.22,0,0,0,0,.18h.09a.64.64,0,0,0-.19.25.63.63,0,0,0,0,.27c0,.07,0,.13.06.14h0s0,.13.07.15l.07,0s0,.07.08.07.07,0,.07,0,0,0,.06,0,.09-.15.14-.2a1.19,1.19,0,0,0,.22-.26.52.52,0,0,1,.19-.28c.11-.06.87-.38,1.06-.45a5.79,5.79,0,0,0,1-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M32.45,24.94a.37.37,0,0,0-.14,0l0,.09a.12.12,0,0,1-.12.07v0s.06,0,.09,0l0,0s0,0,0,.09.23.27.32.25.12-.05.14-.23S32.56,25,32.45,24.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M32.29,25.93a1,1,0,0,0,0-.15l0-.07a1.74,1.74,0,0,0,.1-.16.2.2,0,0,0,0-.1l.06.09-.12.17V26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M32.43,26a.2.2,0,0,0,0-.1.28.28,0,0,1,0-.05l.1-.21.08.07a.44.44,0,0,0-.11.12,1.23,1.23,0,0,0,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M32.14,25.82l0-.16c0-.06,0-.16,0-.17l.08-.09-.09-.07a.78.78,0,0,1,0,.09s-.06.1-.06.13,0,.14,0,.17A.64.64,0,0,0,32.14,25.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "32.77 24.78 33.05 25.29 35.03 24.45 34.48 23.64 32.77 24.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35,32.72a1.18,1.18,0,0,0-.58.14l-.2.19a.62.62,0,0,0-.33.53.69.69,0,0,0,.4.6l1.75,1a1.48,1.48,0,0,0,.7.17,1.09,1.09,0,0,0,.58-.14l.82-.36a.62.62,0,0,0,.33-.53.7.7,0,0,0-.4-.6l-2.36-.77A1.49,1.49,0,0,0,35,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.21,33.06a.59.59,0,0,0-.32.51.69.69,0,0,0,.38.58l1.72.93a1.43,1.43,0,0,0,.68.17,1.26,1.26,0,0,0,.57-.13l.15-.08.63-.28a.59.59,0,0,0,.32-.51.7.7,0,0,0-.39-.58l-2.3-.75a1.28,1.28,0,0,0-.68-.18,1.44,1.44,0,0,0-.37,0l-.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.22,33.07a.58.58,0,0,0-.3.49.66.66,0,0,0,.37.56L36,35a1.39,1.39,0,0,0,.65.16,1.06,1.06,0,0,0,.55-.12l.15-.07.61-.28a.56.56,0,0,0,.3-.5.74.74,0,0,0-.39-.56l-2.22-.73a1.36,1.36,0,0,0-.67-.17,1.34,1.34,0,0,0-.35.05.56.56,0,0,0-.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.24,33.08a.55.55,0,0,0-.3.47.64.64,0,0,0,.36.54L36,35a1.35,1.35,0,0,0,.64.16,1.08,1.08,0,0,0,.52-.12l.15-.07.58-.26a.53.53,0,0,0,.28-.49.71.71,0,0,0-.38-.54l-2.14-.72a1.42,1.42,0,0,0-.65-.16,1.29,1.29,0,0,0-.35,0l-.18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.26,33.09a.52.52,0,0,0-.29.45.63.63,0,0,0,.35.52l1.62.87a1.42,1.42,0,0,0,.62.16,1,1,0,0,0,.5-.12l.14-.07.57-.25a.5.5,0,0,0,.26-.48.71.71,0,0,0-.37-.51L35.58,33A1.21,1.21,0,0,0,35,32.8a1.14,1.14,0,0,0-.33.05l-.18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.27,33.1a.51.51,0,0,0-.27.43.61.61,0,0,0,.33.5l1.6.85a1.15,1.15,0,0,0,.59.15,1,1,0,0,0,.48-.11l.14-.06.54-.25a.48.48,0,0,0,.25-.46.78.78,0,0,0-.37-.5l-2-.68a1.15,1.15,0,0,0-.61-.15,1,1,0,0,0-.32,0l-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.29,33.11a.48.48,0,0,0-.26.41.56.56,0,0,0,.32.48l1.56.83a1.3,1.3,0,0,0,.57.15,1,1,0,0,0,.47-.11l.13-.06.52-.24a.43.43,0,0,0,.22-.45.71.71,0,0,0-.36-.47L35.53,33a1.18,1.18,0,0,0-.9-.09.61.61,0,0,0-.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M34.3,33.12a.47.47,0,0,0-.24.39.53.53,0,0,0,.3.45l1.54.82a1.06,1.06,0,0,0,.54.14.93.93,0,0,0,.45-.1.67.67,0,0,0,.12-.06l.5-.22a.42.42,0,0,0,.21-.44.72.72,0,0,0-.35-.45L35.51,33a1.2,1.2,0,0,0-.57-.14,1.34,1.34,0,0,0-.3,0l-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M34.32,33.13a.44.44,0,0,0-.24.37.52.52,0,0,0,.3.43l1.5.8a1.12,1.12,0,0,0,.52.14.85.85,0,0,0,.43-.1l.12-.05.47-.22a.39.39,0,0,0,.2-.43.74.74,0,0,0-.35-.42L35.49,33a1.16,1.16,0,0,0-.56-.14,1.35,1.35,0,0,0-.29.05l-.15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M34.34,33.14a.4.4,0,0,0-.23.35.48.48,0,0,0,.28.41l1.47.78a1,1,0,0,0,.5.13.88.88,0,0,0,.41-.09l.12,0,.45-.21a.33.33,0,0,0,.17-.41c0-.14-.19-.32-.34-.41L35.46,33a1,1,0,0,0-.53-.13.82.82,0,0,0-.28,0L34.5,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M34.35,33.15a.4.4,0,0,0-.21.33.48.48,0,0,0,.26.39l1.45.76a1,1,0,0,0,.47.13.8.8,0,0,0,.39-.09l.11-.05.43-.2a.3.3,0,0,0,.16-.4c0-.12-.2-.3-.33-.38L35.44,33a1.14,1.14,0,0,0-.52-.12.76.76,0,0,0-.27.05l-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M34.37,33.16a.37.37,0,0,0-.2.32.44.44,0,0,0,.25.36l1.41.74a.87.87,0,0,0,.45.12.79.79,0,0,0,.38-.08l.1,0,.41-.19a.29.29,0,0,0,.14-.39c0-.12-.21-.29-.33-.36l-1.57-.59a.93.93,0,0,0-.5-.12.7.7,0,0,0-.25,0l-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M34.39,33.17a.33.33,0,0,0-.19.3.41.41,0,0,0,.23.34l1.38.73a.92.92,0,0,0,.43.11.8.8,0,0,0,.36-.07l.1,0,.38-.18A.26.26,0,0,0,37.2,34c0-.1-.21-.27-.32-.34l-1.49-.57a.87.87,0,0,0-.48-.11.86.86,0,0,0-.24,0l-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M34.4,33.18a.33.33,0,0,0-.17.28.4.4,0,0,0,.22.32l1.35.71a.88.88,0,0,0,.4.1.71.71,0,0,0,.34-.06l.09-.05.37-.17a.24.24,0,0,0,.1-.36c0-.09-.22-.26-.31-.32l-1.42-.56a.93.93,0,0,0-.47-.1.85.85,0,0,0-.23,0l-.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M34.42,33.19a.3.3,0,0,0-.17.26.37.37,0,0,0,.21.29l1.32.7a.83.83,0,0,0,.38.1.79.79,0,0,0,.32-.06l.09,0,.34-.17a.22.22,0,0,0,.09-.35c0-.08-.23-.24-.31-.29l-1.35-.54a.74.74,0,0,0-.44-.1.72.72,0,0,0-.22,0l-.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M34.43,33.2a.29.29,0,0,0-.15.24.33.33,0,0,0,.2.27l1.29.68a.71.71,0,0,0,.36.09.54.54,0,0,0,.29,0l.08,0,.32-.15a.21.21,0,0,0,.08-.34c0-.07-.24-.23-.31-.27l-1.27-.53a.88.88,0,0,0-.43-.1l-.21,0-.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M34.45,33.21a.25.25,0,0,0-.14.22.33.33,0,0,0,.18.25l1.26.66a.78.78,0,0,0,.34.09.64.64,0,0,0,.28,0l.07,0,.3-.14a.2.2,0,0,0,0-.33c0-.06-.23-.21-.29-.25l-1.21-.51a.76.76,0,0,0-.4-.09l-.2,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M34.47,33.22a.22.22,0,0,0-.13.2.29.29,0,0,0,.17.23l1.22.64a.66.66,0,0,0,.32.08.57.57,0,0,0,.26,0l.07,0,.27-.14a.18.18,0,0,0,0-.31c0-.05-.24-.2-.29-.23l-1.13-.49a.65.65,0,0,0-.39-.09.59.59,0,0,0-.19.05l-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M34.48,33.23a.22.22,0,0,0-.11.18.27.27,0,0,0,.15.21l1.2.62a.55.55,0,0,0,.29.08.61.61,0,0,0,.24,0l.06,0,.26-.13c.13-.07.13-.2,0-.3a1.34,1.34,0,0,0-.29-.2l-1-.48a.69.69,0,0,0-.37-.08.48.48,0,0,0-.18,0l-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M34.5,33.24a.18.18,0,0,0-.1.16.23.23,0,0,0,.14.19l1.16.6a.61.61,0,0,0,.27.08.51.51,0,0,0,.22,0l.06,0,.23-.12c.13-.07.12-.19,0-.28s-.25-.17-.27-.18l-1-.47a.6.6,0,0,0-.35-.07.38.38,0,0,0-.16,0l-.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M34.52,33.25a.17.17,0,0,0-.1.14.26.26,0,0,0,.13.17l1.13.58a.52.52,0,0,0,.25.07.44.44,0,0,0,.2,0l.06,0,.2-.11c.13-.07.12-.19,0-.28s-.26-.15-.27-.16l-.91-.45a.63.63,0,0,0-.33-.06.42.42,0,0,0-.16,0l-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M34.72,33.16l-.19.1c-.12.07-.1.19,0,.26l1.11.57a.48.48,0,0,0,.45,0l.19-.1c.12-.07.1-.19,0-.26l-1.11-.57A.48.48,0,0,0,34.72,33.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.12,36.5a1.18,1.18,0,0,0-.58.14l-.2.19a.62.62,0,0,0-.33.53.69.69,0,0,0,.4.6l1.75.95a1.48,1.48,0,0,0,.7.17,1.09,1.09,0,0,0,.58-.14l.82-.36a.62.62,0,0,0,.33-.53.7.7,0,0,0-.4-.6l-2.36-.77A1.49,1.49,0,0,0,28.12,36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27.36,36.84a.59.59,0,0,0-.32.51.69.69,0,0,0,.38.58l1.72.93a1.43,1.43,0,0,0,.68.17,1.19,1.19,0,0,0,.56-.13l.16-.08.63-.28a.59.59,0,0,0,.32-.52.69.69,0,0,0-.4-.57L28.8,36.7a1.3,1.3,0,0,0-.68-.18,1.44,1.44,0,0,0-.37,0l-.2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.37,36.85a.58.58,0,0,0-.31.49.67.67,0,0,0,.38.56l1.69.91a1.39,1.39,0,0,0,.65.16,1.06,1.06,0,0,0,.55-.12l.15-.07.61-.28a.56.56,0,0,0,.3-.5.74.74,0,0,0-.39-.56l-2.22-.73a1.36,1.36,0,0,0-.67-.17,1.34,1.34,0,0,0-.35.05.56.56,0,0,0-.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.39,36.86a.55.55,0,0,0-.3.47.64.64,0,0,0,.36.54l1.66.89a1.34,1.34,0,0,0,.63.16,1.12,1.12,0,0,0,.53-.12l.15-.07.58-.26a.53.53,0,0,0,.28-.5.71.71,0,0,0-.38-.53l-2.14-.72a1.42,1.42,0,0,0-.65-.16,1.29,1.29,0,0,0-.35,0l-.18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.41,36.87a.52.52,0,0,0-.29.45.63.63,0,0,0,.35.52l1.62.87a1.39,1.39,0,0,0,.62.16,1,1,0,0,0,.5-.12l.14-.07.57-.25a.5.5,0,0,0,.26-.48.7.7,0,0,0-.38-.51l-2.07-.7a1.21,1.21,0,0,0-.63-.16,1.14,1.14,0,0,0-.33.05l-.18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.42,36.88a.51.51,0,0,0-.27.43.61.61,0,0,0,.33.5l1.6.85a1.13,1.13,0,0,0,.59.15,1,1,0,0,0,.48-.11l.14-.06.54-.25a.48.48,0,0,0,.25-.46.78.78,0,0,0-.37-.5l-2-.68a1.18,1.18,0,0,0-.61-.15,1,1,0,0,0-.32,0l-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M27.44,36.89a.48.48,0,0,0-.26.41.53.53,0,0,0,.32.47l1.56.84a1.3,1.3,0,0,0,.57.15,1,1,0,0,0,.46-.11l.14-.06.51-.24A.42.42,0,0,0,31,37.9a.74.74,0,0,0-.36-.47l-1.93-.67a1.08,1.08,0,0,0-.59-.14,1,1,0,0,0-.31.05.61.61,0,0,0-.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M27.45,36.9a.45.45,0,0,0-.24.39.53.53,0,0,0,.3.45l1.53.82a1.12,1.12,0,0,0,.55.14.93.93,0,0,0,.45-.1l.12-.06.5-.22a.42.42,0,0,0,.21-.44.74.74,0,0,0-.36-.45l-1.85-.66a1.2,1.2,0,0,0-.57-.14,1.34,1.34,0,0,0-.3,0l-.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M27.47,36.91a.44.44,0,0,0-.24.37.51.51,0,0,0,.29.43l1.51.8a1.12,1.12,0,0,0,.52.14.85.85,0,0,0,.43-.1l.12,0,.47-.22a.39.39,0,0,0,.2-.43.78.78,0,0,0-.35-.42l-1.79-.64a1.1,1.1,0,0,0-.55-.14,1.35,1.35,0,0,0-.29.05l-.15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M27.49,36.92a.4.4,0,0,0-.23.35.48.48,0,0,0,.28.41l1.47.78a1,1,0,0,0,.5.13.88.88,0,0,0,.41-.09l.11,0,.46-.21a.33.33,0,0,0,.17-.41c0-.14-.19-.32-.34-.41l-1.71-.62a1.08,1.08,0,0,0-.54-.13.76.76,0,0,0-.27,0l-.15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M27.5,36.93a.4.4,0,0,0-.21.33.48.48,0,0,0,.26.39l1.45.76a1,1,0,0,0,.47.13.8.8,0,0,0,.39-.09L30,38.4l.43-.2a.31.31,0,0,0,.16-.4c0-.12-.2-.3-.34-.38l-1.63-.61a1.14,1.14,0,0,0-.52-.12.76.76,0,0,0-.27.05l-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M27.52,36.94a.37.37,0,0,0-.2.31.44.44,0,0,0,.25.37l1.41.74a.87.87,0,0,0,.45.12.72.72,0,0,0,.37-.08l.11,0,.41-.19a.29.29,0,0,0,.14-.39c0-.12-.21-.29-.33-.36l-1.57-.59a.85.85,0,0,0-.5-.12.7.7,0,0,0-.25,0l-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M27.53,37a.34.34,0,0,0-.18.3.41.41,0,0,0,.23.34l1.38.72a.93.93,0,0,0,.43.12.83.83,0,0,0,.36-.07l.09,0,.39-.18a.26.26,0,0,0,.12-.38c0-.1-.21-.27-.32-.34l-1.49-.57a.87.87,0,0,0-.48-.11.86.86,0,0,0-.24,0l-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M27.55,37a.31.31,0,0,0-.17.28.4.4,0,0,0,.22.32l1.35.71a.88.88,0,0,0,.4.1.74.74,0,0,0,.34-.06l.09-.05.36-.17a.24.24,0,0,0,.11-.36c0-.09-.22-.26-.32-.32l-1.42-.56a.89.89,0,0,0-.46-.1.85.85,0,0,0-.23,0l-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.57,37a.29.29,0,0,0-.17.26.35.35,0,0,0,.21.29l1.32.7a.83.83,0,0,0,.38.1.79.79,0,0,0,.32-.06l.09,0,.34-.17a.22.22,0,0,0,.09-.35c0-.08-.23-.24-.31-.29l-1.35-.54a.75.75,0,0,0-.44-.1.72.72,0,0,0-.22,0l-.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M27.58,37a.27.27,0,0,0-.15.24.33.33,0,0,0,.2.27l1.28.68a.77.77,0,0,0,.36.09.58.58,0,0,0,.3,0l.08,0L30,38a.2.2,0,0,0,.07-.33c0-.07-.23-.23-.3-.27l-1.27-.53a.88.88,0,0,0-.43-.1l-.21,0-.11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M27.6,37a.25.25,0,0,0-.14.22.33.33,0,0,0,.18.25l1.26.66a.71.71,0,0,0,.34.09.57.57,0,0,0,.27-.05l.08,0,.3-.14a.2.2,0,0,0,.05-.33c0-.06-.24-.21-.3-.25l-1.2-.51a.76.76,0,0,0-.4-.09l-.2.05-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M27.62,37a.22.22,0,0,0-.13.2.29.29,0,0,0,.17.23l1.22.64a.66.66,0,0,0,.32.08.57.57,0,0,0,.26,0l.07,0,.27-.14a.18.18,0,0,0,0-.31c0-.05-.24-.2-.29-.23l-1.13-.49a.66.66,0,0,0-.39-.09.59.59,0,0,0-.19,0l-.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M27.63,37a.21.21,0,0,0-.11.18.27.27,0,0,0,.15.21l1.2.62a.55.55,0,0,0,.29.08.64.64,0,0,0,.24,0l.06,0,.26-.13c.13-.07.13-.2,0-.3a1.26,1.26,0,0,0-.28-.2l-1.06-.48a.64.64,0,0,0-.36-.08.48.48,0,0,0-.18,0l-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M27.65,37a.16.16,0,0,0-.1.16.23.23,0,0,0,.13.19l1.17.6a.5.5,0,0,0,.27.07.4.4,0,0,0,.22,0l.06,0,.23-.12c.13-.07.12-.19,0-.28a1.12,1.12,0,0,0-.28-.18l-1-.47a.6.6,0,0,0-.35-.07.47.47,0,0,0-.17,0l-.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M27.66,37a.17.17,0,0,0-.09.14.26.26,0,0,0,.13.17l1.13.58a.52.52,0,0,0,.25.07.64.64,0,0,0,.2,0l.06,0,.2-.11c.13-.07.12-.19,0-.28l-.27-.16-.91-.45a.63.63,0,0,0-.33-.06.42.42,0,0,0-.16,0l-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M27.87,36.94l-.19.1c-.12.07-.1.19,0,.26l1.11.57a.48.48,0,0,0,.45,0l.19-.1c.11-.07.1-.19,0-.26L28.32,37A.48.48,0,0,0,27.87,36.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M35.34,21.58c.28.06.63,0,.37.75s0,3.51-.17,4.61c0,.28-.68.35-.68.35a22.26,22.26,0,0,1-.77-3.35,11,11,0,0,1,.39-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M34.89,22.54l-.1-.12.2-.18h0l.15.24-.12.08L34.89,25l-.12,1.23A4.13,4.13,0,0,1,34.58,25,21.34,21.34,0,0,1,34.89,22.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M35.14,32.79l0,.2a.21.21,0,0,1-.11.23l-.11.05a8.28,8.28,0,0,1-.83.4c-.23,0-.4,0-.4-.1s.05-.18.27-.32a1.51,1.51,0,0,0,.4-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M35.16,33a4,4,0,0,0-.5.21,1.83,1.83,0,0,1-.63.36c-.17,0-.3-.06-.28-.12s.18-.18.31-.29a1.48,1.48,0,0,0,.29-.34l.78-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M34.26,26.46s-.2,3.14-.2,3.44.27,2.69.3,2.92.79.19.79,0-.07-2.61-.07-2.61l.67-3.27-.12-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M35.08,30.17s.06,2.44.07,2.61-.11.14-.24.17L34.55,30l.66-3.24.54.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M36.83,33.63v.21a.25.25,0,0,1-.07.2l-.07.06a1.55,1.55,0,0,1-.43.41.66.66,0,0,1-.61.06c-.07-.06-.07-.11.11-.35l.44-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M36.81,33.82a2.6,2.6,0,0,0-.35.39.75.75,0,0,1-.74.3c-.24-.08.09-.33.15-.44l.25-.38h.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M35.39,26.6s.66,6.94.7,7.11.73.15.74-.11.17-5.73.2-6a4.72,4.72,0,0,0,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M36.28,26.66l.77-.15a4.82,4.82,0,0,1,0,1.08c0,.28-.19,5.73-.2,6,0,.09-.08.14-.19.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M35.84,21.89c0,.22-.29.59-.55.72,0,0-.29-.35-.29-.35s-.33.28-.34.27a1.5,1.5,0,0,1-.09-.56c0-.2.26-.38.61-.41S35.83,21.69,35.84,21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M34.77,21.51a1,1,0,0,0-.59.26A2.12,2.12,0,0,0,34,22.82c0,.21,0,2.7.06,3.23s0,.84.06,1.07.53.4.59.26a10.73,10.73,0,0,0-.12-1.79c0-.38-.07-2.53,0-3.5A.7.7,0,0,1,34.77,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M35.44,21.57s.42.1.32.41a17,17,0,0,0-.59,1.6,13.81,13.81,0,0,0-.05,3.89c.1.3,2.15.33,2.11-.27,0-.18-.12-4.25-.22-4.55s-.76-.7-1.17-.91A2.28,2.28,0,0,0,35.44,21.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M34.65,21c0-.13.16-.27.38-.3s.43.05.45.18h0l.22,1c0,.16-.19.32-.46.36s-.51-.06-.54-.22l-.05-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M35.38,21.36a1.68,1.68,0,0,0,0-.57.53.53,0,0,0-.4-.09c-.22,0-.39.17-.38.3h0l.05,1a.31.31,0,0,0,0,.1A1.26,1.26,0,0,0,35.38,21.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M34.33,20.33c-.19.36,0,1.55.35,1.55s.73-.45.83-.76.1-.94-.23-1.1A.72.72,0,0,0,34.33,20.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M36.68,25.3l-.41-1.75.35-1.07.29,0a.62.62,0,0,1,.1.2c.1.3.21,4.37.22,4.55s-.34.39-.78.46l0-.87s-.41.4-.65.42-.57-.09-.58-.31c0,0,.47,0,.47,0l.45-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M35.11,20.64a4.51,4.51,0,0,1,.1.65c0,.12-.29.24-.29.24a1,1,0,0,0-.39-.13.44.44,0,0,0-.2,0,.6.6,0,0,0,.27.46c.23.12.63-.21.72-.36s0-.47,0-.59.07-.13.12-.11,0,.36.1.43.13-.15.14-.42.09-1-.51-1a1.07,1.07,0,0,0-1.1.46c-.08.25,0,.47.47.45A1.82,1.82,0,0,0,35.11,20.64Zm-.37,1a.27.27,0,0,1-.17,0c-.13,0-.14-.05-.14-.05s0-.09.09-.07h.12A.11.11,0,0,1,34.74,21.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "31.24 27.58 31.24 29.97 33.54 28.64 33.54 26.22 31.24 27.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "31.24 27.58 31.24 29.97 29.05 28.71 29.05 26.3 31.24 27.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "29.05 26.3 31.24 27.58 33.54 26.22 31.35 24.95 29.05 26.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "29.05 26.3 31.24 27.58 33.54 26.22 31.24 27.54 29.05 26.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "32.22 27.02 32.22 27.66 32.74 27.36 32.74 26.7 32.22 27.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "30.03 25.73 32.22 27.02 32.74 26.7 30.54 25.42 30.03 25.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "31.68 28.45 31.49 29.01 31.61 28.95 31.61 29.62 31.74 29.55 31.74 28.87 31.86 28.8 31.68 28.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-303",
    points: "32.3 28.55 32.12 28.19 31.94 28.76 32.06 28.69 32.06 29.36 32.18 29.29 32.18 28.61 32.3 28.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M27.24,37.3a.51.51,0,0,0,0,.26.26.26,0,0,0,.34.07c.13-.06.19-.2.24-.24a1.57,1.57,0,0,0,.56-.25c.22-.19.19-.39,0-.39a1.77,1.77,0,0,0-.75.19A2.11,2.11,0,0,0,27.24,37.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M27.34,37.5a.61.61,0,0,0,.44-.18c.1-.08.26,0,.47-.2s.28-.28.19-.34a1,1,0,0,0-.72.11l-.45.25s-.07.2,0,.25S27.25,37.48,27.34,37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M27.5,30.07s-.26.15-.22.74c0,.16-.07,6.51-.07,6.51a.74.74,0,0,0,.34,0,1.76,1.76,0,0,0,.38-.23l.94-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M29.1,37.9s-.08.24,0,.29a.53.53,0,0,0,.41,0c.14-.05.19-.11.34-.11a2.08,2.08,0,0,0,.8-.37c.11-.12,0-.26-.26-.25s-.65.05-.72.07S29.1,37.9,29.1,37.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M29.22,38.07a1.49,1.49,0,0,0,.56-.07c.23,0,.89-.29.88-.42s-.17-.11-.29-.1l-.57,0s-.69.27-.69.27-.05.19,0,.22S29.16,38.07,29.22,38.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M28.24,29.65A1.82,1.82,0,0,0,28.12,31c.2.77,1,3.73,1,3.73s-.05,2.81-.05,3.18c0,.11.24.16.49.08s.31-.19.32-.34a32.23,32.23,0,0,0,.34-3.28c0-.94-.22-3.78-.22-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M29.92,37.61a32.23,32.23,0,0,0,.34-3.28c0-.94-.22-3.78-.22-3.78l-.83-.41.08,1.14s0,.14.07.37c.16.83.52,2.78.52,3s-.17,2.14-.25,3.26C29.91,37.84,29.91,37.75,29.92,37.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M28,25.66c-.32.06-.64.15-.69.9s-.19,4.76-.19,4.76a3,3,0,0,0,2,.45c1,0,1-.28,1-.28s.06-2.56.09-3.92c0-.64-.08-.81-.28-1a11.24,11.24,0,0,0-1-.66A1.83,1.83,0,0,0,28,25.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M30.15,31.49s.06-2.55.09-3.92V27.5l-.95-.05c-.14,1.4-.16,4.07-.16,4.07s0,.25-.77.22h0a4.7,4.7,0,0,0,.78,0C30.13,31.74,30.15,31.49,30.15,31.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M29.34,26.24c0,.16-.28.27-.59.25s-.57-.17-.55-.33.27-.27.59-.25S29.35,26.08,29.34,26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M28.28,26.1s0,.07,0,.1a.62.62,0,0,0,.46.2.84.84,0,0,0,.44-.08.15.15,0,0,0,.07-.09l.06-.34s.26,0,.34-.07.38-1.33,0-1.65-1.18-.26-1.32.3a1.47,1.47,0,0,0,.11,1A2.17,2.17,0,0,1,28.28,26.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M28.48,25.57a1.09,1.09,0,0,0,.42.08c.22-.06.23-.58.38-.69s.17,0,.16.11,0,.12,0,.13a2.35,2.35,0,0,0,.19-.43s.59-.25.43-.77c-.2.13-1.42-.55-1.79.35C28,25.06,28.34,25.53,28.48,25.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M28.35,31.88c.07.24.14.49.22.75l-.64,4.5-.2.14C27.85,36.35,28.29,32.44,28.35,31.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M32.82,28.35a2.73,2.73,0,0,0,.29-.27c.08-.08.16-.16.2-.12s-.24.42-.24.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M32.7,28.83a1.62,1.62,0,0,0,.6,0c.2-.07.5-.44.45-.54s-.08,0-.08,0,.07-.07.06-.13,0,0-.11,0a.83.83,0,0,1-.39.17c-.17,0-.29-.06-.4,0a.58.58,0,0,1-.29.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M29.45,26.59a.66.66,0,0,0-.29.89c.19.43,1,1.93,1.41,2a11.34,11.34,0,0,0,2.32-.55,1.78,1.78,0,0,0,0-.39.25.25,0,0,0-.12-.19,7.87,7.87,0,0,1-1.78.16c-.18-.05-.34-.7-.69-1.46C30.08,26.61,29.77,26.41,29.45,26.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M36.61,25.82c-.24.29-.39.54-.43.58a2.29,2.29,0,0,1-.28.24l-.23.2a.43.43,0,0,1-.15,0,.41.41,0,0,0-.19-.06s0,0,0,0a0,0,0,1,0-.08.06.14.14,0,0,0,0,0,0,0,0,0,0,0,.05.46.46,0,0,0,.19.14c.1,0,.25.12.3.1s.23-.06.28-.09.62-.51.86-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M36.45,26.7a1.24,1.24,0,0,0-.31.06.6.6,0,0,1-.28.12c-.06,0-.15,0-.16,0s.08.08.17.08a.78.78,0,0,0,.28-.07.6.6,0,0,1-.27.1,1.19,1.19,0,0,1-.36-.09c-.09-.06-.15-.12-.18-.12s0,.07.08.11a.7.7,0,0,0,.16.1l.3.06a.76.76,0,0,1-.35,0,.45.45,0,0,1-.22-.15s0-.05,0-.05,0,0,0,0h0l0,0s0,0,0,0a.41.41,0,0,0,.17.12c.1,0,.25.12.3.1s.23-.06.28-.09l.43-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M36.09,26.48l-.19.16,0,.05-.12.1h.07c.07,0,.22-.07.35-.18S36.18,26.49,36.09,26.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M35.23,26.86a.1.1,0,0,1,0-.06,0,0,0,0,1,0,0s.14.2.24.24a1.91,1.91,0,0,0,.37.06.16.16,0,0,1-.11,0,.58.58,0,0,1-.28-.07A1.08,1.08,0,0,1,35.23,26.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M36,26.42s0,.08.07.09a.59.59,0,0,1,.2,0,.13.13,0,0,0,.19,0c.11-.08.05-.16-.06-.17S36,26.31,36,26.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M36.22,22.29c-.38.22-.13,1,.08,1.43s.7,1.51.7,1.51l-.78,1.06.34.41a9.55,9.55,0,0,0,1.3-1.36,13.36,13.36,0,0,0-.7-2.54C37,22.38,36.51,22.12,36.22,22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M29.41,25s.75-.29.83-.65-.48-.61-.94-.39S29.41,25,29.41,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M29.41,24.93s.75-.29.83-.66-.48-.6-.94-.38S29.41,24.93,29.41,24.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M28.45,23.8a1,1,0,0,0-.26,1.31,1.54,1.54,0,0,0,1.72-.56C30.1,24.29,29.43,23.19,28.45,23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M28.48,23.84l0,0a1,1,0,0,0-.26,1.25,1,1,0,0,0,.72.06A2,2,0,0,1,28.48,23.84Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportaion01);
export default __webpack_public_path__ + "static/media/Transportaion-01.85088107fb3af2a9f5d228075457d72e.svg";
export { ForwardRef as ReactComponent };